"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasItemOfCostType = exports.hasGrantWriterFee = exports.hasEntityRole = exports.hasChildren = exports.hasBankingPermissions = exports.grantType = exports.getUserEntitiesForEntityType = exports.getUnixtimeFromISO = exports.getUniqs = exports.getTshirtSizePx = exports.getTshirtSizeCol = exports.getTimestampOfISO = exports.getTimestampNowISO = exports.getPercentage = exports.getPartName = exports.getPartIdWithoutChildrenPath = exports.getPanelStatusAlias = exports.getOrgIdFromCurrentLocation = exports.getObjectFromPath = exports.getNumberFromObject = exports.getLastFieldInPath = exports.getItemsOfCostType = exports.getItemNameFromRef = exports.getFundingStreamType = exports.getFirstObjectError = exports.getFirstInvalidErrorMessage = exports.getFirstErrorForField = exports.getExtension = exports.getErrorForField = exports.getDependencyFromState = exports.getBudgetItemsAtTier = exports.generateOptionsFromRefData = exports.gatherPhoneList = exports.formatNumber = exports.formatLongitude = exports.formatLatitude = exports.formatDollarOrEmptyString = exports.formatDollarHyphen = exports.formatDollarDecimalsNullSafe = exports.formatDollarDecimals = exports.formatDollarCommas = exports.formatDateMMDDYYYY = exports.filterExcludedRolesFromPermissions = exports.filterEntities = exports.fillArray = exports.fetchPhaseArray = exports.evaluateOperator = exports.evalSectionStatus = exports.errorMessages = exports.enhanceInline = exports.enhance = exports.endsWith = exports.encode = exports.duplicatePhoneNumbers = exports.duplicateEmails = exports.displayPhoneNumber = exports.displayObjectErrors = exports.cutDateTimeOff = exports.createUUID = exports.countDependenciesToLoad = exports.costBocV2 = exports.costBocV1 = exports.convertValueToPercent = exports.convertValueToDollar = exports.convertToNum = exports.convertToDate = exports.convertDateYYYYMMDD = exports.convertDateWithTimezoneForDisplay = exports.convertDateMMDDYYYY = exports.convertDateForDisplay = exports.contains = exports.compileContent = exports.checkWithinApplicationDeadline = exports.checkIsNum = exports.checkIfValuesAre = exports.checkIfIncludedsIn = exports.checkIfEmailIsValid = exports.checkIfEmailIsFEMA = exports.checkIfDefinedNonNullAndNotEmptyString = exports.checkForValidationErrors = exports.checkForIE = exports.camelCaseToSpaces = exports.calculateTotalFundingStreams = exports.calculateStatuses = exports.calculatePaymentFederalBalance = exports.calculatePaymentDispursements = exports.calculatePOPEndDate = exports.calculateLastNonZeroBudgetPeriod = exports.calculateBOCAggregates = exports.buildParamString = exports.buildOrgRelationshipOrganizationProgramsUrl = exports.buildBookmarkLink = exports.arrSumAsNumber = exports.arrAttrSum = exports.allowNumbersAndPeriods = exports.addBusinessDays = exports.SumOfJsonPathArray = exports.ISOToDisplayDate = exports.FORMATTERS = exports.CurrentYear = void 0;
exports.validatePhoneNumber = exports.validDate = exports.totalGreaterThanZero = exports.toTitleCase = exports.toSysDate = exports.toStartCase = exports.toDisplayDate = exports.stringToNum = exports.sortAndPartitionEmployeesByStartDate = exports.showPercentageAmountWithPercentage = exports.showDollarAmountWithDollar = exports.showDollarAmount = exports.shouldDisplaySection = exports.setTime = exports.secondsFromEpochToDisplayDate = exports.scrollIt = exports.sanitizeNum = exports.sanitizeDate = exports.safeSubstractNoFixed = exports.safeSubstract = exports.safeMult = exports.safeDivide = exports.safeAddReduce = exports.safeAddNoFixed = exports.safeAdd = exports.runCostEstimatePreAwardPhasedProjectRule = exports.runCostEstimatePhasedProjectRule = exports.roundUpOrDown = exports.retrieveRolesFromPermissions = exports.retrievePanelSessionsFromPermissions = exports.retrieveEntityTypeIdsFromPermissions = exports.retrieveEntityIdFromPermissionsWithRoleAndType = exports.retrieveAllEntityIdsFromPermissions = exports.requestDetailsChangesToDisplayString = exports.removeLeadingZeros = exports.reloadPage = exports.phoneTypeProfileToContacts = exports.parseError = exports.onlyTwoDecimals = exports.onlyAllowNumbers = exports.newlyAddedDisasterLocationNames = exports.modalVal = exports.matchesToggle = exports.matchesFOIDForToggle = exports.mapToTextAndValue = exports.mapRefDataCode = exports.mapRefData = exports.mapLocationRefDataByIdOrCode = exports.mapLocationRefDataByIdAndCode = exports.mapLocationRefDataByCode = exports.lessThanTwoUniquePhoneNumbers = exports.isValidUei = exports.isValidDuns = exports.isUserRoleAllowed = exports.isUserOrgProgramAllowed = exports.isUserOrgPrgSuborgSelfSarSm = exports.isToggledOnDependency = exports.isStringOfNumbers = exports.isStringEmpty = exports.isProgramExternal = exports.isNewDisasterLocationAdded = exports.isMissingHiringPosition = exports.isFemaUser = exports.isFemaOrProgramExternal = exports.isDisplayError = exports.isDirty = exports.iconFromExtension = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/esnext.string.replace-all.js");
require("core-js/modules/es.string.match.js");
require("core-js/modules/es.string.pad-start.js");
require("core-js/modules/es.string.pad-end.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.flat-map.js");
require("core-js/modules/es.array.unscopables.flat-map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.string.ends-with.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _jsonpath = _interopRequireDefault(require("jsonpath"));
var _momentBusinessDays = _interopRequireDefault(require("moment-business-days"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _v = _interopRequireDefault(require("uuid/v4"));
var _HOCs = require("../go/components/common/FormControls/HOCs");
var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));
var _mathjs = require("mathjs");
var _constants = require("./constants");
var _coreJs = require("core-js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } //import REST from 'go/requests/rest';
// import PermissionChecks, {
//   canViewAmendmentsAndPayments,
//   canViewAndContinueApplication,
//   canContinueApplications,
//   canReopenApplications,
//   canContinueSubapplicationSubmitted,
//   canViewSubapplication,
//   canViewAndContinueSubapplication,
//   isSM,
//   rfiSectionCheck,
// } from 'go/security/permissions';
// import {SARROLES, AOR_SAR_ROLES} from 'go/components/organization/team/constants';
// import {countQuantityOfItem} from 'go/components/modules/requestDetails/v2/utils';
// import {
//   calculateChildrenTotalByMode,
//   calculateItemCostTotal,
// } from 'common/requestDetails/utils';
//import {FUNDING_STREAM_NAME, PAYMENT} from 'common/requestDetails/constants.js';
// import {
//   PROPERTY_TYPES_CODES,
//   PROPERTY_TYPES_LABELS,
// } from 'go/components/dynamic/modules/projectSiteInventory/constants';
// import {
//   SUBAPPLICATION_PATHS,
//   SUBAPPLICATION_RANK_ERROR_MSGS,
// } from 'go/components/application/constants';
// import {email_regex} from 'go/components/organization/team/constants';
//import goStore from 'go/store';
//import {unpartitionedToggleIsOn} from 'common/storeUtils';

var phoneTypeProfileToContacts = function phoneTypeProfileToContacts(type) {
  return _lodash.default.toLower(_lodash.default.get(_lodash.default.find(_constants.profilePhoneNumberOptions, function (option) {
    return option.value == type;
  }), 'text', _lodash.default.get(_lodash.default.find(_constants.phoneNumberOptions, function (option) {
    return option.value == type;
  }), 'text', '')));
};
exports.phoneTypeProfileToContacts = phoneTypeProfileToContacts;
var filterEntities = function filterEntities(entities, excludedIds, includedStatuses) {
  return _lodash.default.filter(entities, function (entity) {
    return !_lodash.default.includes(excludedIds, entity.entityId) && _lodash.default.includes(includedStatuses, entity.status);
  });
};
exports.filterEntities = filterEntities;
var getItemsOfCostTypeHelper = function getItemsOfCostTypeHelper(item, refs, costType, path) {
  var items = [];
  var itemCostType = _lodash.default.get(_lodash.default.find(refs, function (ref) {
    return ref.itemCode === item.itemCode;
  }), 'costType');
  if (costType === itemCostType) {
    var itemToPush = _lodash.default.cloneDeep(item);
    itemToPush.awardedId = _lodash.default.join(path, '.');
    items.push(itemToPush);
  }
  _lodash.default.forEach(item.children, function (child, pathKey) {
    items = _lodash.default.concat(items, getItemsOfCostTypeHelper(child, refs, costType, [].concat(_toConsumableArray(path), ['children', pathKey])));
  });
  return items;
};
var getItemsOfCostType = function getItemsOfCostType(fundingStreams, refs, costType) {
  var items = [];
  _lodash.default.forEach(fundingStreams, function (stream, streamInd) {
    _lodash.default.forEach(stream.children, function (child, childKey) {
      items = _lodash.default.concat(items, getItemsOfCostTypeHelper(child, refs, costType, [streamInd, 'children', childKey]));
    });
  });
  return items;
};
exports.getItemsOfCostType = getItemsOfCostType;
var hasItemOfCostType = function hasItemOfCostType(fundingStreams, refs, costType) {
  return _lodash.default.size(getItemsOfCostType(fundingStreams, refs, costType)) > 0;
};
exports.hasItemOfCostType = hasItemOfCostType;
var sortAndPartitionEmployeesByStartDate = function sortAndPartitionEmployeesByStartDate(position) {
  var sortedPosition = _lodash.default.reverse(_lodash.default.sortBy(position, function (pos) {
    return (0, _momentTimezone.default)(pos.startDate).valueOf();
  }));
  return _lodash.default.partition(sortedPosition, function (pos) {
    return !pos.endDate;
  });
};
exports.sortAndPartitionEmployeesByStartDate = sortAndPartitionEmployeesByStartDate;
var checkForValidationErrors = function checkForValidationErrors(errs, componentsToCheck) {
  var errorComponents = [];
  if (errs && componentsToCheck) {
    _lodash.default.forEach(componentsToCheck, function (comp) {
      var err = errs[comp];
      if (err) {
        _lodash.default.forEach(err, function (error) {
          if (!error.isValid) {
            errorComponents.push(comp);
            return false;
          }
        });
      }
    });
  }
  return errorComponents;
};
exports.checkForValidationErrors = checkForValidationErrors;
var getPropValues = function getPropValues(o, prop) {
  return function (validationIdList) {
    return JSON.stringify(o, function (key, value) {
      return key === prop && validationIdList.push(value), value;
    }), validationIdList;
  }([]);
};
var shouldDisplaySection = function shouldDisplaySection(section, props, shouldDisplay) {
  if (section.type === 'ShowHide') {
    var isHidden = !shouldDisplay(undefined, undefined, section.shouldDisplayRules, props);
    if (isHidden) {
      return false;
    }
  }
  return true;
};
exports.shouldDisplaySection = shouldDisplaySection;
var evalSectionStatus = function evalSectionStatus(section, allValidationErrors) {
  var validationIdList = getPropValues(section, 'validationId');
  var errorInSection = false;
  _lodash.default.forEach(validationIdList, function (validationId) {
    if (!_lodash.default.isEmpty(validationId)) {
      var errorList = _lodash.default.get(allValidationErrors.errors, validationId);
      if (!_lodash.default.isEmpty(errorList)) {
        var errorFound = _lodash.default.find(errorList, function (err) {
          return err.isValid === false;
        });
        if (errorFound !== undefined) {
          errorInSection = true;
        }
      }
    }
  });
  return errorInSection ? 'needsAttention' : 'complete';
};

/** UTILITY FUNCTIONS SITE-WIDE **/
exports.evalSectionStatus = evalSectionStatus;
var generateOptionsFromRefData = function generateOptionsFromRefData(ids, list, compareItem) {
  var formattedList = [];
  _lodash.default.forEach(ids, function (id) {
    _lodash.default.forEach(list, function (item) {
      if (compareItem !== undefined) {
        if (id[compareItem] === item.id) {
          formattedList.push(item);
        }
      } else if (id === item.id) {
        formattedList.push(item);
      }
    });
  });
  return mapRefData(formattedList);
};
exports.generateOptionsFromRefData = generateOptionsFromRefData;
var mapRefData = function mapRefData(obj) {
  return _lodash.default.map(obj, function (x) {
    return mapToTextAndValue(x.displayText, x.id);
  });
};
exports.mapRefData = mapRefData;
var mapRefDataCode = function mapRefDataCode(obj) {
  return _lodash.default.map(obj, function (x) {
    return mapToTextAndValue(x.displayText, x.code);
  });
};
exports.mapRefDataCode = mapRefDataCode;
var mapLocationRefDataByIdOrCode = function mapLocationRefDataByIdOrCode(obj, type) {
  return _lodash.default.map(obj, function (item) {
    var _item$displayText = item.displayText,
      displayText = _item$displayText === void 0 ? '' : _item$displayText,
      _item$code = item.code,
      code = _item$code === void 0 ? '' : _item$code,
      _item$id = item.id,
      id = _item$id === void 0 ? '' : _item$id,
      _item$displayOrder = item.displayOrder,
      displayOrder = _item$displayOrder === void 0 ? '' : _item$displayOrder;
    return {
      text: displayText,
      value: type === 'code' ? code : displayText,
      key: type === 'code' ? code : id,
      displayOrder: displayOrder
    };
  });
};
exports.mapLocationRefDataByIdOrCode = mapLocationRefDataByIdOrCode;
var mapLocationRefDataByIdAndCode = function mapLocationRefDataByIdAndCode(obj, type) {
  return _lodash.default.map(obj, function (item) {
    var _item$displayText2 = item.displayText,
      displayText = _item$displayText2 === void 0 ? '' : _item$displayText2,
      _item$code2 = item.code,
      code = _item$code2 === void 0 ? '' : _item$code2,
      _item$id2 = item.id,
      id = _item$id2 === void 0 ? '' : _item$id2,
      _item$displayOrder2 = item.displayOrder,
      displayOrder = _item$displayOrder2 === void 0 ? '' : _item$displayOrder2;
    return {
      text: displayText,
      value: type === 'code' ? code : displayText,
      key: type === 'code' ? code : id,
      displayOrder: displayOrder,
      id: id
    };
  });
};
exports.mapLocationRefDataByIdAndCode = mapLocationRefDataByIdAndCode;
var mapLocationRefDataByCode = function mapLocationRefDataByCode(obj, type) {
  return _lodash.default.map(obj, function (item) {
    var refObj = {};
    refObj.text = type === 'code' ? item.code : '';
    return refObj;
  });
};
exports.mapLocationRefDataByCode = mapLocationRefDataByCode;
var mapToTextAndValue = function mapToTextAndValue(text, value) {
  return {
    key: value,
    value: value,
    text: text
  };
};
exports.mapToTextAndValue = mapToTextAndValue;
var isValidDuns = function isValidDuns(dunsNum, isDunsPlus4) {
  if (dunsNum) {
    dunsNum = dunsNum.toString().replace(/\D/g, 'X');
    var isValidLength = dunsNum.length === 9 || dunsNum.length === 13;
    if (isDunsPlus4) {
      isValidLength = dunsNum.length === 4;
    }
    return dunsNum && isValidLength && !isNaN(dunsNum);
  }
  return false;
};
exports.isValidDuns = isValidDuns;
var isValidUei = function isValidUei(uei, isEft) {
  if (uei) {
    var isValidLength = uei.length === 12 || uei.length === 17 && uei.includes('-');
    if (isEft) {
      isValidLength = uei.length === 4;
    }
    return uei && isValidLength;
  }
  return false;
};
exports.isValidUei = isValidUei;
var checkIsNum = function checkIsNum(o) {
  return typeof o === 'number' && !isNaN(o);
};
exports.checkIsNum = checkIsNum;
var cutDateTimeOff = function cutDateTimeOff(date) {
  if (date === null || date === undefined || typeof date !== 'string') {
    return '';
  }
  return date.substr(0, 10);
};
exports.cutDateTimeOff = cutDateTimeOff;
var formatDateMMDDYYYY = function formatDateMMDDYYYY(value) {
  var date = cutDateTimeOff(value);
  if (date === '') {
    return '';
  }
  var year = getYear(date);
  var month = getMonth(date);
  var day = getDay(date);
  return month + '/' + day + '/' + year;
};
exports.formatDateMMDDYYYY = formatDateMMDDYYYY;
var getYear = function getYear(date) {
  return date.substring(0, 4);
};
var getMonth = function getMonth(date) {
  var newDate = date.slice(5);
  return newDate.substr(0, 2);
};
var getDay = function getDay(date) {
  return date.substr(8, 10);
};

// takes a string describing a number and makes sure it has 2 decimals at the end
// e.g 10 -> 10.00 or 23.3 -> 23.30 or 23.4044 -> 23.40
var formatDollarDecimals = function formatDollarDecimals(valueString) {
  var indexPeriod = valueString.indexOf('.');
  var indexAfterPeriod = indexPeriod + 1;
  // value is a float, format according to dollar syntax
  if (indexPeriod !== -1) {
    var valTruncated = valueString.substring(0, indexAfterPeriod);
    var decimals = valueString.substring(indexAfterPeriod);
    switch (decimals.length) {
      case 0:
        {
          decimals += '00';
          break;
        }
      case 1:
        {
          decimals += '0';
          break;
        }
      default:
        {
          decimals = decimals.substring(0, 2);
          break;
        }
    }
    return valTruncated + decimals;
    // value is an integer, just add decimals to string
  } else {
    return valueString + '.00';
  }
};
exports.formatDollarDecimals = formatDollarDecimals;
var formatDollarHyphen = function formatDollarHyphen(valueString) {
  var hasHyphen = valueString.indexOf('-') !== -1;
  if (hasHyphen) {
    return '-' + valueString.replaceAll('-', '');
  } else {
    return valueString;
  }
};

// takes a string describing a number and makes sure it has commas at
// appropriate places 10.00 -> 10.00, 1000 -> 1,000, 100000.0 -> 100,000.0
exports.formatDollarHyphen = formatDollarHyphen;
var formatDollarCommas = function formatDollarCommas(valueString) {
  var hasDecimal = valueString.indexOf('.') !== -1;
  var parts = valueString.split('.');
  if (parts[0].length === 0) {
    parts[0] = '0';
  } else {
    // TODO merge the first 2 regex
    // 1. Remove all leading 0's except last
    // 2. Remove leading zero if it is not alone (0.00 should be valid)
    // 3. add in commas
    parts[0] = parts[0].replace(/^0+(?=0)/, '').replace(/^0(?!0)(?=\w)/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  if (hasDecimal) {
    return parts.join('.');
  } else {
    return parts[0];
  }
};

// take a string and remove all but 2 characters after the string's first '.'
exports.formatDollarCommas = formatDollarCommas;
var onlyTwoDecimals = function onlyTwoDecimals(value) {
  var splitAtDecimal = value.split('.');
  if (splitAtDecimal.length < 2) {
    return splitAtDecimal[0];
  } else if (splitAtDecimal[1].length < 2) {
    return value;
  } else {
    splitAtDecimal[1] = splitAtDecimal[1].substring(0, 2);
    return splitAtDecimal.join('.');
  }
};
exports.onlyTwoDecimals = onlyTwoDecimals;
var convertValueToDollar = function convertValueToDollar(value) {
  if (value !== null && value !== undefined) {
    var num = onlyAllowNumbers(value.toString());
    return showDollarAmountWithDollar(num);
  } else {
    return showDollarAmountWithDollar(value);
  }
};

// do not use directly if also displaying a dollar sign
// use showDollarAmountwithDollar for consistent formatting
exports.convertValueToDollar = convertValueToDollar;
var showDollarAmount = function showDollarAmount(value) {
  var num = value;
  if (!num || isNaN(num)) {
    return 0;
  } else {
    return formatDollarDecimals(formatDollarCommas(num.toString()));
  }
};
exports.showDollarAmount = showDollarAmount;
var formatDollarDecimalsNullSafe = function formatDollarDecimalsNullSafe(value) {
  var num = value;
  if (!num || isNaN(num)) {
    return 0;
  } else {
    return formatDollarDecimals(num.toString());
  }
};
exports.formatDollarDecimalsNullSafe = formatDollarDecimalsNullSafe;
var showDollarAmountWithDollar = function showDollarAmountWithDollar(value) {
  var num = value;
  if (isNaN(num) || value === '' || value === null || typeof value === 'undefined') {
    return '$';
    // negative numbers should be in '-$xx.xx' format:: 2299
  } else if (num < 0) {
    return '-$' + showDollarAmount(0 - num);
  } else {
    return '$' + showDollarAmount(num);
  }
};
exports.showDollarAmountWithDollar = showDollarAmountWithDollar;
var showPercentageAmountWithPercentage = function showPercentageAmountWithPercentage(value) {
  if (isNaN(value) || checkIfValuesAre([null, undefined, '', ' '], value)) {
    return ' %';
  }
  return formatNumber(value) + ' %';
};
exports.showPercentageAmountWithPercentage = showPercentageAmountWithPercentage;
var formatNumber = function formatNumber(value) {
  if (value !== null && !isNaN(value)) {
    var num = value.toString();
    if (num === '0') {
      return '0';
    }
    var parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  } else {
    return null;
  }
};
exports.formatNumber = formatNumber;
var stringToNum = function stringToNum(value) {
  var str = value.toString();
  return parseFloat(str.replace(/\$|,/g, ''));
};
exports.stringToNum = stringToNum;
var onlyAllowNumbers = function onlyAllowNumbers(value, positiveOnly) {
  if (typeof value !== 'undefined' && value !== null) {
    if (positiveOnly) {
      value = value.toString().replace(/[^0-9\.]/g, '');
    } else {
      value = value.toString().replace(/[^0-9\.\-]/g, '');
    }
    var indOfPeriod = value.indexOf('.');
    if (indOfPeriod !== -1) {
      var noPeriodValue = value.replace(/\./g, '');
      value = noPeriodValue.substring(0, indOfPeriod) + '.' + noPeriodValue.substring(indOfPeriod, noPeriodValue.length);
    }
    return value.replace(/\.+(?=\.)/g, '');
  } else {
    return value;
  }
};
exports.onlyAllowNumbers = onlyAllowNumbers;
var allowNumbersAndPeriods = function allowNumbersAndPeriods(value) {
  if (value !== null && value !== undefined && value.match(/^(\d*\.?\d{0,2})$/)) {
    return value.match(/^(\d*\.?\d{0,2})$/)[0];
  } else {
    return false;
  }
};

// converts to an integer
exports.allowNumbersAndPeriods = allowNumbersAndPeriods;
var convertToNum = function convertToNum(value, config) {
  if (value !== null && value !== undefined) {
    var str = value.toString();
    str = str.replace('$', '');
    str = str.replace('%', '');
    str = str.replace(' ', '');
    str = str.replace(/,/g, '');
    if (isNaN(parseInt(str, 10))) {
      value = null;
    } else {
      value = _lodash.default.get(config, 'convertToInt') === false ? str : parseInt(str, 10);
    }
  }
  return value;
};
exports.convertToNum = convertToNum;
var sanitizeNum = function sanitizeNum(value) {
  if (value !== null && value !== undefined) {
    var str = value.toString();
    str = str.replace(/,/g, '');
    return str;
  }
  return value;
};
exports.sanitizeNum = sanitizeNum;
var endsWith = function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
};
exports.endsWith = endsWith;
var sanitizeDate = function sanitizeDate(field) {
  if (field) {
    var dateToSanitize = cutDateTimeOff(field);
    dateToSanitize = new Date(dateToSanitize);
    dateToSanitize.setUTCHours(12, 0, 0, 0);
    dateToSanitize = dateToSanitize.toISOString();
    return dateToSanitize;
  } else {
    return null;
  }
};
exports.sanitizeDate = sanitizeDate;
var formatLatitude = function formatLatitude(input) {
  var value = +input;
  if (isNaN(value)) {
    return;
  }
  var isNegative = value < 0 ? '-' : '';
  var parts = Math.abs(value).toString().split('.');
  if (parts.length === 1) {
    var nums = parts[0];
    parts[0] = nums.substr(0, 2);
    parts[1] = nums.substr(2, 6);
  }
  return isNegative + parts[0].padStart(2, '0') + '.' + parts[1].padEnd(6, '0').substr(0, 6);
};
exports.formatLatitude = formatLatitude;
var formatLongitude = function formatLongitude(input) {
  var value = +input;
  if (isNaN(value)) {
    return;
  }
  var isNegative = value < 0 ? '-' : '';
  var parts = Math.abs(value).toString().split('.');
  if (parts.length === 1) {
    var nums = parts[0];
    parts[0] = nums.substr(0, 3);
    parts[1] = nums.substr(3, 6);
  }
  return isNegative + parts[0].padStart(3, '0') + '.' + parts[1].padEnd(6, '0').substr(0, 6);
};
exports.formatLongitude = formatLongitude;
var FORMATTERS = {
  formatLatitude: formatLatitude,
  formatLongitude: formatLongitude
};

// export const commonJwtHeader = () => {
//   const state = goStore.store.getState();
//   const token = _.get(state, 'auth.token');
//   var headers = {
//     'Content-Type': 'application/json',
//     pragma: 'no-cache',
//     'cache-control': 'no-cache',
//   };
//   if (!token) {
//     return headers;
//   }
//   if (isHttpOnlyCookie()) {
//     headers._csrftoken = token._csrftoken;
//   } else {
//     headers.Authorization = 'Bearer ' + token;
//   }
//   return headers;
// };

// export const commonJwtHeaderNoCT = () => {
//   let headers = commonJwtHeader();
//   delete headers['Content-Type'];
//   return headers;
// };

// export const getUpdatedReduxStatePayload = (data, dataPath, updatedData) => {
//   let path = `payload.${dataPath}`;
//   let dataCloned = Object.assign({}, data);
//   if (dataPath === '') {
//     path = 'payload';
//   }
//   _.set(dataCloned, path, updatedData);
//   return dataCloned;
// };

// export const getUpdatedReduxState = (data, dataPath, updatedData) => {
//   let path = dataPath || '';
//   _.set(data, path, updatedData);
//   return data;
// };
// export const removeDataFromReduxState = (data, dataPath) => {
//   _.unset(data, dataPath);
//   return data;
// };

/** This is used to generate the unique ID needed for react rows. When in prod.. we will probably already have a unique key that we could use, but for now I'm generating a random one.
 * @return {text}
 */
exports.FORMATTERS = FORMATTERS;
var createUUID = function createUUID() {
  return (0, _v.default)();
};

/**
 * Checks if value is in array
 * @param {[]} array
 * @param {string} value
 */
exports.createUUID = createUUID;
var checkIfIncludedsIn = function checkIfIncludedsIn(array, value) {
  return _lodash.default.some(array, function (arrayValue) {
    return arrayValue === value;
  });
};
exports.checkIfIncludedsIn = checkIfIncludedsIn;
var invalidNumber = function invalidNumber(number, length) {
  return !number || number.length != length || isNaN(number);
};
var validatePhoneNumber = function validatePhoneNumber(number) {
  var areaCode = number.areaCode,
    phoneNumber = number.phoneNumber,
    phoneType = number.phoneType,
    phoneExtension = number.phoneExtension;
  number.phoneError = invalidNumber(areaCode, 3) || invalidNumber(phoneNumber, 7);
  number.phoneTypeError = !phoneType;
  number.phoneExtensionError = phoneExtension && isNaN(phoneExtension);
  return number.phoneError || number.phoneTypeError || number.phoneExtensionError;
};
exports.validatePhoneNumber = validatePhoneNumber;
var getOutOfSequenceNumbers = function getOutOfSequenceNumbers(numbers, total) {
  var result = [];
  // Only if all entered
  if (_lodash.default.size(numbers) === total) {
    for (var i = 1; i < total + 1; i++) {
      if (!_lodash.default.includes(numbers, i)) {
        result.push(i);
      }
    }
  }
  return result;
};

// const getAllSubapplicationRanks = (linksData) => {
//   const allRanks = _.map(linksData, (link) => {
//     return {
//       entityId: link.entityId,
//       payload: {
//         rank: _.get(link, SUBAPPLICATION_PATHS.rank),
//       },
//     };
//   });
//   return allRanks;
// };

// export const validateSubapplication = (entityId, props) => {
//   let {errors = {}} = props;
//   const {applicationLinksData, categoryLabel} = props;
//   const allRanks = getAllSubapplicationRanks(applicationLinksData);

//   // Only ranks for the entities in the same category
//   const subApplicationCategory = _.chain(applicationLinksData)
//     .find({entityId: entityId})
//     .get(SUBAPPLICATION_PATHS.subAppCategory)
//     .value();

//   const excludedRankCategories = ['Management costs', 'Technical assistance'];

//   // Getting result rows with the same category
//   const newResultsForRanks = _.chain(applicationLinksData)
//     .filter((result) => {
//       return (
//         _.get(result, SUBAPPLICATION_PATHS.subAppCategory) === subApplicationCategory
//       );
//     })
//     .reduce((accum, res) => {
//       accum.push(res.entityId);
//       return accum;
//     }, [])
//     .value();

//   if (allRanks && !_.includes(excludedRankCategories, subApplicationCategory)) {
//     // Getting ranks for results with the category from above
//     const newRanks = _.filter(allRanks, (rank) => {
//       return _.includes(newResultsForRanks, rank.entityId);
//     });
//     let ranks = [];
//     let ranksToo = [];
//     _.forEach(newRanks, (item) => {
//       const rank = _.get(item, SUBAPPLICATION_PATHS.rank, undefined);
//       if (rank !== undefined && item.entityId !== entityId) {
//         ranks.push(parseInt(rank, 10));
//         ranksToo.push({entityId: item.entityId, rank: parseInt(rank, 10)});
//       }
//     });
//     const rankInput = _.chain(applicationLinksData)
//       .find((res) => res.entityId === entityId)
//       .get(SUBAPPLICATION_PATHS.rank, '')
//       .value();

//     const rank = parseFloat(rankInput, 10);

//     let outOfSequenceNums = [];
//     if (!isNaN(rank)) {
//       outOfSequenceNums = getOutOfSequenceNumbers(
//         _.concat(_.map(ranksToo, 'rank'), rank),
//         _.size(newResultsForRanks)
//       );
//     }

//     // Field level validations
//     if (isNaN(rank) || typeof rank === 'undefined') {
//       _.set(
//         errors,
//         [entityId, 'rank', 'errorMessage'],
//         SUBAPPLICATION_RANK_ERROR_MSGS.default
//       );
//     } else if (rank % 1 !== 0 || toString(rankInput).indexOf('.') > -1) {
//       _.set(
//         errors,
//         [entityId, 'rank', 'errorMessage'],
//         SUBAPPLICATION_RANK_ERROR_MSGS.wholeNumber
//       );
//     } else if (rank === 0 || rank < 0) {
//       _.set(
//         errors,
//         [entityId, 'rank', 'errorMessage'],
//         SUBAPPLICATION_RANK_ERROR_MSGS.positiveNumber
//       );
//     } else if (isStringOfNumbers(rankInput)) {
//       _.set(
//         errors,
//         [entityId, 'rank', 'errorMessage'],
//         SUBAPPLICATION_RANK_ERROR_MSGS.default
//       );
//     } else if (_.includes(_.map(ranksToo, 'rank'), rank)) {
//       _.set(
//         errors,
//         [entityId, 'rank', 'errorMessage'],
//         SUBAPPLICATION_RANK_ERROR_MSGS.duplicates
//       );
//     } else {
//       _.unset(errors, [entityId, 'rank', 'errorMessage']);
//       // Re-check and unset other duplicates errors if needed
//       let counts = {};
//       _.forEach(ranksToo, (row) => {
//         counts[row.rank] = (counts[row.rank] || 0) + 1;
//       });
//       _.forEach(ranksToo, (row) => {
//         if (counts[row.rank] > 1) {
//           _.set(
//             errors,
//             [row.entityId, 'rank', 'errorMessage'],
//             SUBAPPLICATION_RANK_ERROR_MSGS.duplicates
//           );
//         } else {
//           _.unset(errors, [row.entityId, 'rank', 'errorMessage']);
//         }
//       });
//     }
//     // Category level validations
//     if (_.size(outOfSequenceNums) > 0) {
//       _.set(
//         errors,
//         [subApplicationCategory, 'errorTitle'],
//         'Rankings must be sequential'
//       );
//       _.set(
//         errors,
//         [subApplicationCategory, 'errorMessage'],
//         categoryLabel +
//           ' rankings must be sequential (1, 2, 3, ...). This ' +
//           _.toLower(categoryLabel) +
//           ' has ' +
//           _.size(_.concat(ranks, rank)) +
//           ' subapplications and is missing ranking value(s) '
//       );
//       _.set(
//         errors,
//         [subApplicationCategory, 'errorExtras'],
//         _.join(outOfSequenceNums, ', ') + '.'
//       );
//     } else if (_.size(ranks) == 0 && rank !== 1) {
//       _.set(errors, [subApplicationCategory, 'errorTitle'], 'Rankings must start with 1');
//       _.set(
//         errors,
//         [subApplicationCategory, 'errorMessage'],
//         'You must have a subapplication with ranking value of 1.'
//       );
//       _.set(errors, [subApplicationCategory, 'errorExtras'], '');
//     } else {
//       _.unset(errors, [subApplicationCategory, 'errorMessage']);
//     }
//   } else {
//     _.unset(errors, [subApplicationCategory, 'errorMessage']);
//   }

//   // Category level validations for Technical Assistance and Management Costs
//   if (
//     _.size(newResultsForRanks) > 1 &&
//     _.includes(excludedRankCategories, subApplicationCategory)
//   ) {
//     _.set(
//       errors,
//       [subApplicationCategory, 'errorTitle'],
//       'Only one subapplication allowed'
//     );
//     _.set(
//       errors,
//       [subApplicationCategory, 'errorMessage'],
//       'This funding category can only have one subapplication. Please remove any additional subapplication(s).'
//     );
//   } else {
//     const technicalAssistance = 'technical assistance';
//     const managementCosts = 'management costs';
//     _.forEach(applicationLinksData, (item) => {
//       const subAppCategory = _.get(item, SUBAPPLICATION_PATHS.subAppCategory, '');
//       const lowersubApplicationType = _.chain(item)
//         .get('subApplicationType', '')
//         .toLower()
//         .value();
//       if (_.toLower(subAppCategory) === technicalAssistance) {
//         if (lowersubApplicationType.indexOf(technicalAssistance) === -1) {
//           _.set(
//             errors,
//             [subAppCategory, 'errorTitle'],
//             'Only technical assistance subapplications allowed'
//           );
//           _.set(
//             errors,
//             [subAppCategory, 'errorMessage'],
//             `This ${_.toLower(
//               categoryLabel
//             )} can only have a subapplication with the technical assistance type. Please remove any subapplication(s) that are not this type.`
//           );
//         }
//       } else if (_.toLower(subAppCategory) === managementCosts) {
//         if (managementCosts.indexOf(lowersubApplicationType) === -1) {
//           _.set(
//             errors,
//             [subAppCategory, 'errorTitle'],
//             'Only management costs subapplications allowed'
//           );
//           _.set(
//             errors,
//             [subAppCategory, 'errorMessage'],
//             `This ${_.toLower(
//               categoryLabel
//             )} can only have a subapplication with the management costs type. Please remove any subapplication(s) that are not this type.`
//           );
//         }
//       }
//     });
//   }

//   return errors;
// };

// export const validateAllSubapplications = (props) => {
//   let errors = {};
//   const {applicationLinksData, categoryLabel} = props;

//   _.forEach(applicationLinksData, (row) => {
//     const validationProps = {
//       applicationLinksData: applicationLinksData,
//       categoryLabel: categoryLabel,
//     };
//     _.merge(errors, validateSubapplication(row.entityId, validationProps));
//   });

//   return errors;
// };

var displayPhoneNumber = function displayPhoneNumber(areaCode, phoneNumber) {
  var value = '';
  if (areaCode) {
    value += '(' + areaCode;
  }
  if (phoneNumber) {
    value += ') ' + phoneNumber.substr(0, 3);
    if (phoneNumber.length > 3) {
      value += '-' + phoneNumber.substr(3, 7);
    }
  }
  return value;
};
exports.displayPhoneNumber = displayPhoneNumber;
var getLastFieldInPath = function getLastFieldInPath(path) {
  return path.substr(path.lastIndexOf('.') + 1, path.length);
};
// /**
//  * retrieveEntityIdFromPermissions takes array of state.auth.permissions and reeturns the entityId
//  * @param {[]} array
//  * @return {string}
//  */
// export const retrieveEntityIdFromPermissions = (permissions) => {
//   if (_.isEmpty(permissions)) {
//     return '';
//   } else {
//     return permissions[0].charAt(0);
//   }
// };
exports.getLastFieldInPath = getLastFieldInPath;
var retrieveAllEntityIdsFromPermissions = function retrieveAllEntityIdsFromPermissions(permissions) {
  if (_lodash.default.isEmpty(permissions)) {
    return '';
  } else {
    return _lodash.default.uniq(_lodash.default.map(permissions, function (permission) {
      return permission.charAt(0);
    }));
  }
};
exports.retrieveAllEntityIdsFromPermissions = retrieveAllEntityIdsFromPermissions;
var getUserEntitiesForEntityType = function getUserEntitiesForEntityType(permissions, entityType) {
  return _lodash.default.chain(permissions).map(function (permission) {
    var _permission$split = permission.split(':'),
      _permission$split2 = _slicedToArray(_permission$split, 3),
      entityTypeId = _permission$split2[0],
      entityId = _permission$split2[1],
      roleId = _permission$split2[2];
    if (entityTypeId === entityType && entityId) {
      return entityId;
    }
  }).filter(function (sessionId) {
    return sessionId !== undefined;
  }).uniq().value();
};

/**
 * retrieveRolesFromPermissions takes array of state.auth.permissions and returns an array of roleIds
 * @param {[]} array
 * @return {string}
 */
exports.getUserEntitiesForEntityType = getUserEntitiesForEntityType;
var retrieveRolesFromPermissions = function retrieveRolesFromPermissions(permissions) {
  var re = /[^:]*$/;
  if (_lodash.default.isEmpty(permissions)) {
    return [];
  } else {
    return _lodash.default.uniq(_lodash.default.map(permissions, function (permission) {
      return permission.match(re)[0];
    }));
  }
};
exports.retrieveRolesFromPermissions = retrieveRolesFromPermissions;
var retrieveEntityTypeIdsFromPermissions = function retrieveEntityTypeIdsFromPermissions(permissions) {
  if (_lodash.default.isEmpty(permissions)) {
    return [];
  } else {
    return _lodash.default.uniq(_lodash.default.map(permissions, function (permission) {
      return permission.split(':')[0];
    }));
  }
};
exports.retrieveEntityTypeIdsFromPermissions = retrieveEntityTypeIdsFromPermissions;
var retrievePanelSessionsFromPermissions = function retrievePanelSessionsFromPermissions(permissions) {
  if (_lodash.default.isEmpty(permissions)) {
    return [];
  } else {
    return _lodash.default.chain(permissions).map(function (permission) {
      var _permission$split3 = permission.split(':'),
        _permission$split4 = _slicedToArray(_permission$split3, 3),
        entityTypeId = _permission$split4[0],
        panelSessionId = _permission$split4[1],
        role = _permission$split4[2];
      if (entityTypeId == _constants.ENTITY_MAP.PANEL_REVIEW.code && (role == _constants.ROLE_MAP.PC.code || role == _constants.ROLE_MAP.PR.code || role == _constants.ROLE_MAP.PRC.code || role == _constants.ROLE_MAP.PANELADMIN.code)) {
        return panelSessionId;
      }
    }).filter(function (sessionId) {
      return sessionId !== undefined;
    }).uniq().value();
  }
};
exports.retrievePanelSessionsFromPermissions = retrievePanelSessionsFromPermissions;
var retrieveEntityIdFromPermissionsWithRoleAndType = function retrieveEntityIdFromPermissionsWithRoleAndType(permissions, roleToCheck, entityType) {
  if (_lodash.default.isEmpty(permissions)) {
    return [];
  } else {
    return _lodash.default.chain(permissions).map(function (permission) {
      var _permission$split5 = permission.split(':'),
        _permission$split6 = _slicedToArray(_permission$split5, 3),
        entityTypeId = _permission$split6[0],
        entityId = _permission$split6[1],
        role = _permission$split6[2];
      if (role == roleToCheck && entityTypeId == entityType) {
        return entityId;
      }
    }).filter(function (entityId) {
      return entityId !== undefined;
    }).uniq().value();
  }
};
exports.retrieveEntityIdFromPermissionsWithRoleAndType = retrieveEntityIdFromPermissionsWithRoleAndType;
var isUserRoleAllowed = function isUserRoleAllowed(permissions, orgId, roleId) {
  if (_lodash.default.isEmpty(permissions)) {
    return false;
  } else {
    return _lodash.default.chain(permissions).map(function (permission) {
      var _permission$split7 = permission.split(':'),
        _permission$split8 = _slicedToArray(_permission$split7, 3),
        entityTypeId = _permission$split8[0],
        entityId = _permission$split8[1],
        role = _permission$split8[2];
      if (entityId == orgId && entityTypeId == _constants.ENTITY_MAP.ORGANIZATION.code && role == roleId) {
        return true;
      }
    }).filter(function (value) {
      return value !== undefined;
    }).uniq().value()[0];
  }
};
exports.isUserRoleAllowed = isUserRoleAllowed;
var isUserOrgProgramAllowed = function isUserOrgProgramAllowed(permissions, orgId, roleId) {
  if (_lodash.default.isEmpty(permissions)) {
    return false;
  } else {
    return _lodash.default.chain(permissions).map(function (permission) {
      var _permission$split9 = permission.split(':'),
        _permission$split10 = _slicedToArray(_permission$split9, 3),
        entityTypeId = _permission$split10[0],
        entityId = _permission$split10[1],
        role = _permission$split10[2];
      entityId = entityId.split('_')[0];
      if (entityId == orgId && entityTypeId == _constants.ENTITY_MAP.PROGRAM_ORGANIZATION.code && role == roleId) {
        return true;
      }
    }).filter(function (value) {
      return value !== undefined;
    }).uniq().value()[0];
  }
};
exports.isUserOrgProgramAllowed = isUserOrgProgramAllowed;
var isUserOrgPrgSuborgSelfSarSm = function isUserOrgPrgSuborgSelfSarSm(permissions, suborgId, roleId) {
  if (_lodash.default.isEmpty(permissions)) {
    return false;
  } else {
    return _lodash.default.chain(permissions).map(function (permission) {
      var _permission$split11 = permission.split(':'),
        _permission$split12 = _slicedToArray(_permission$split11, 3),
        entityTypeId = _permission$split12[0],
        entityId = _permission$split12[1],
        role = _permission$split12[2];
      var entityIdFromPermission = entityId.split('_')[0];
      var suborgIdFromPermission = entityId.split('_')[2];
      if (entityIdFromPermission == suborgIdFromPermission && entityIdFromPermission == suborgId && suborgIdFromPermission == suborgId && entityTypeId == _constants.ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code && role == roleId) {
        return true;
      } else {
        return false;
      }
    }).filter(function (value) {
      return value !== undefined && value === true;
    }).uniq().value()[0];
  }
};

/**
 * isFemaUser compares the entityId and checks whether it is fema or non fema
 * @param {[]} array
 * @return {boolean}
 */
exports.isUserOrgPrgSuborgSelfSarSm = isUserOrgPrgSuborgSelfSarSm;
var isFemaUser = function isFemaUser(permissions) {
  var entityIds = retrieveAllEntityIdsFromPermissions(permissions);
  return _lodash.default.includes(entityIds, _constants.ENTITY_MAP.PROGRAM.code) || _lodash.default.includes(entityIds, _constants.ENTITY_MAP.REPORT_CATEGORY.code);
};
exports.isFemaUser = isFemaUser;
var isProgramExternal = function isProgramExternal(permissions) {
  return _lodash.default.includes(retrieveAllEntityIdsFromPermissions(permissions), _constants.ENTITY_MAP.PROGRAM_EXTERNAL.code);
};
exports.isProgramExternal = isProgramExternal;
var isFemaOrProgramExternal = function isFemaOrProgramExternal(permissions) {
  return isFemaUser(permissions) || isProgramExternal(permissions);
};
exports.isFemaOrProgramExternal = isFemaOrProgramExternal;
var hasBankingPermissions = function hasBankingPermissions(permissions) {
  var roles = retrieveRolesFromPermissions(permissions);
  // If at least one role is in permissions array:
  return _lodash.default.difference(roles, _constants.BANKING_PERMISSION_ROLES).length !== roles.length;
};
exports.hasBankingPermissions = hasBankingPermissions;
var getOrgIdFromCurrentLocation = function getOrgIdFromCurrentLocation(state) {
  if (state.router.location.pathname) {
    return state.router.location.pathname.split('/').pop();
  }
  return '';
};
exports.getOrgIdFromCurrentLocation = getOrgIdFromCurrentLocation;
var hasEntityRole = function hasEntityRole(state, role) {
  var bool = false;
  if (state.auth.permissions === []) {
    return false;
  } else {
    _lodash.default.forEach(state.auth.permissions, function (permission) {
      if (permission.match(role)) {
        bool = true;
        return false;
      }
    });
  }
  return bool;
};
// export const countHiringOfFirefighterPaymentsGreaterThan = (paymentList) => {
//   let newList = _.filter(paymentList, (payment) => {
//     return payment.entityType === PAYMENT && payment.status === STATUS_PENDING_SUBMISSION;
//   });
//   return newList.length;
// };
exports.hasEntityRole = hasEntityRole;
var getTshirtSizeCol = function getTshirtSizeCol(size) {
  var width;
  switch (size) {
    case 'small':
      width = '5';
      break;
    case 'medium':
      width = '9';
      break;
    case 'large':
      width = '13';
      break;
    default:
      width = '16';
  }
  return width;
};
exports.getTshirtSizeCol = getTshirtSizeCol;
var getTshirtSizePx = function getTshirtSizePx(size) {
  var width;
  switch (size) {
    case 'xxsmall':
      width = '100px';
      break;
    case 'xsmall':
      width = '150px';
      break;
    case 'small':
      width = '200px';
      break;
    case 'medium':
      width = '300px';
      break;
    case 'large':
      width = '400px';
      break;
    default:
      width = '500px';
  }
  return width;
};
exports.getTshirtSizePx = getTshirtSizePx;
var enhance = function enhance(c) {
  return (0, _HOCs.withGuidance)((0, _HOCs.withValidation)(c));
};
exports.enhance = enhance;
var enhanceInline = function enhanceInline(c) {
  return (0, _HOCs.withGuidance)((0, _HOCs.withValidation)(c, true, true));
};

// same as GET, but treats empty string as full object
exports.enhanceInline = enhanceInline;
var getObjectFromPath = function getObjectFromPath(obj, path) {
  return path !== '' ? _lodash.default.get(obj, path) : obj;
};

// for use in the dynamic framework only, not in individual components
// if you're thinking of using it in a component, you should probably be
// using the framework for dependency gathering
exports.getObjectFromPath = getObjectFromPath;
var getDependencyFromState = function getDependencyFromState(reduxState, path) {
  var splitPath = _lodash.default.split(path, '.');
  var root = _lodash.default.get(splitPath, 0);
  // places that you can have as dependencies outside dynamicComponent { 'myProp': 'profile.a.b' }
  var ALLOWED_OTHER_ROOTS = ['profile'];
  if (_lodash.default.includes(ALLOWED_OTHER_ROOTS, root)) {
    return getObjectFromPath(reduxState, path);
  } else {
    return getObjectFromPath(_lodash.default.get(reduxState, 'dynamicComponent'), path);
  }
};
exports.getDependencyFromState = getDependencyFromState;
var checkForIE = function checkForIE() {
  if (navigator.appVersion.indexOf('MSIE 10') !== -1 || navigator.userAgent.indexOf('Trident/7.0') !== -1) {
    return true;
  }
  return false;
};
exports.checkForIE = checkForIE;
var convertToDate = function convertToDate(value) {
  if (value) {
    value = (0, _momentTimezone.default)(value);
  }
  return value;
};
exports.convertToDate = convertToDate;
var convertDateMMDDYYYY = function convertDateMMDDYYYY(value) {
  if (value) {
    var length = value.length;
    if (length === 10 && /^\d{4}-\d{2}-\d{2}/.test(value) && checkForIE()) {
      value = (0, _momentTimezone.default)(value).format('MM/DD/YYYY');
    }
  }
  return value;
};
exports.convertDateMMDDYYYY = convertDateMMDDYYYY;
var convertDateForDisplay = function convertDateForDisplay(value, inMilli) {
  if (value) {
    if (inMilli || /^\d{4}-\d{2}-\d{2}/.test(value)) {
      if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
        value = value.substring(0, 10);
      }
      value = (0, _momentTimezone.default)(value).format('MM/DD/YYYY');
    }
  }
  return value;
};
exports.convertDateForDisplay = convertDateForDisplay;
var convertDateWithTimezoneForDisplay = function convertDateWithTimezoneForDisplay(value, timezone, inMilli) {
  if (value) {
    if (inMilli || /^\d{4}-\d{2}-\d{2}/.test(value)) {
      if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
        value = value.substring(0, 10);
      }
      value = _momentTimezone.default.tz(value, timezone).format('MM/DD/YYYY');
    }
  }
  return value;
};
exports.convertDateWithTimezoneForDisplay = convertDateWithTimezoneForDisplay;
var convertDateYYYYMMDD = function convertDateYYYYMMDD(value) {
  if (value) {
    if (/^\d{1,2}\/\d{1,2}\/\d{4}/.test(value) && checkForIE()) {
      value = (0, _momentTimezone.default)(value).format('YYYY-MM-DD');
    }
  }
  return value;
};
exports.convertDateYYYYMMDD = convertDateYYYYMMDD;
var validDate = function validDate(value, format) {
  return (0, _momentTimezone.default)(value, format, true).isValid();
};
exports.validDate = validDate;
var toSysDate = function toSysDate(date) {
  var result = (0, _momentTimezone.default)(date, 'MM/DD/YYYY', true);
  if (!result.isValid()) {
    return date;
  }
  return result.format('YYYY-MM-DD');
};
exports.toSysDate = toSysDate;
var toDisplayDate = function toDisplayDate(date) {
  var result = (0, _momentTimezone.default)(date, 'YYYY-MM-DD', true);
  if (!result.isValid()) {
    return date;
  }
  return result.format('MM/DD/YYYY');
};
exports.toDisplayDate = toDisplayDate;
var CurrentYear = function CurrentYear(addOrSubtract) {
  return safeAdd(new Date().getFullYear(), addOrSubtract);
};
exports.CurrentYear = CurrentYear;
var SumOfJsonPathArray = function SumOfJsonPathArray(data, jsonPathPattern, arrayIndex) {
  var sum = 0;
  _lodash.default.forEach(_jsonpath.default.nodes(data, jsonPathPattern), function (node) {
    var array = node.value;
    if (array && array.length > arrayIndex && !_lodash.default.isNaN(_lodash.default.toNumber(array[arrayIndex]))) {
      sum += _lodash.default.toNumber(array[arrayIndex]);
    }
  });
  return sum;
};
exports.SumOfJsonPathArray = SumOfJsonPathArray;
var ISOToDisplayDate = function ISOToDisplayDate(value) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var showHours = config.showHours,
    showDate = config.showDate,
    showTimeZone = config.showTimeZone,
    describeMonth = config.describeMonth,
    useUserTimezone = config.useUserTimezone,
    twentyFour = config.twentyFour,
    ISOString = config.ISOString,
    strictFormattingString = config.strictFormattingString;
  if (value) {
    var zone = useUserTimezone ? _momentTimezone.default.tz.guess() : _constants.MOMENT_EST;
    if (ISOString) {
      value = (0, _momentTimezone.default)(value).format();
    } else {
      var dateString = describeMonth ? "MMMM DD, YYYY".concat(showHours ? ',' : '') : 'MM/DD/YYYY';
      var hourString = twentyFour ? 'H:mm' : 'h:mm a';
      var z = showHours && showTimeZone ? ' z' : '';
      var hr = showHours ? hourString : '';
      var dt = showDate ? dateString : '';
      var delimiter = dt && hr ? ' ' : '';
      var result;
      if (!!strictFormattingString) {
        result = _momentTimezone.default.tz(value, strictFormattingString, true, zone);
      } else {
        result = _momentTimezone.default.tz(value, zone);
      }
      if (result.isValid()) {
        value = result.format(dt + delimiter + hr + z);
      }
    }
  }
  return value;
};
exports.ISOToDisplayDate = ISOToDisplayDate;
var getTimestampOfISO = function getTimestampOfISO(value) {
  return (0, _momentTimezone.default)(value).toISOString();
};
exports.getTimestampOfISO = getTimestampOfISO;
var getTimestampNowISO = function getTimestampNowISO() {
  return _momentTimezone.default.tz(_momentTimezone.default.tz.guess() || _constants.MOMENT_EST).format();
};
exports.getTimestampNowISO = getTimestampNowISO;
var getUnixtimeFromISO = function getUnixtimeFromISO(value) {
  return (0, _momentTimezone.default)(value).unix();
};
exports.getUnixtimeFromISO = getUnixtimeFromISO;
var secondsFromEpochToDisplayDate = function secondsFromEpochToDisplayDate(value, showHours) {
  if (value) {
    value = value * 1000;
    if (showHours) {
      value = _momentTimezone.default.tz(value, _constants.MOMENT_EST).format('MM/DD/YYYY h:mm a');
    } else {
      value = (0, _momentTimezone.default)(value).format('MM/DD/YYYY');
    }
  }
  return value;
};
exports.secondsFromEpochToDisplayDate = secondsFromEpochToDisplayDate;
var getPercentage = function getPercentage(remainder, target) {
  if (remainder != null && target != null) {
    return (remainder / target * 100).toFixed(0) + '%';
  }
  return null;
};
exports.getPercentage = getPercentage;
var convertValueToPercent = function convertValueToPercent(value) {
  if (value) {
    value = parseFloat(value).toFixed(2) + ' %';
  } else {
    value = '000.00 %';
  }
  return value;
};
exports.convertValueToPercent = convertValueToPercent;
var checkIfValuesAre = function checkIfValuesAre(array, value) {
  var _iterator = _createForOfIteratorHelper(array),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var a = _step.value;
      if (_lodash.default.isEqual(a, value)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
};
exports.checkIfValuesAre = checkIfValuesAre;
var checkIfDefinedNonNullAndNotEmptyString = function checkIfDefinedNonNullAndNotEmptyString(value) {
  return !checkIfValuesAre([null, undefined, ''], value);
};
exports.checkIfDefinedNonNullAndNotEmptyString = checkIfDefinedNonNullAndNotEmptyString;
var toTitleCase = function toTitleCase(str) {
  return _lodash.default.map(_lodash.default.split(_lodash.default.toLower(str), /\s+/g), _lodash.default.upperFirst).join(' ');
};
exports.toTitleCase = toTitleCase;
var LABEL_MAPPINGS = {
  nationalstateregional: 'National/State/Regional Programs and Studies',
  sprinklerawarness: 'Sprinkler Awareness',
  generalprevention: 'General Prevention/Awareness',
  wildlandfireprevention: 'Wildland Fire Prevention Programs',
  riskassessments: 'Risk Assessments',
  juvenilefiresetter: 'Juvenile Firesetter Program',
  smokealarmcampaign: 'Smoke Alarm Campaign',
  publiceducation: 'Public Education',
  publiceducation2: 'Public Education 2',
  codeenforcementawareness: 'Code Enforcement/Awareness',
  firearsoninvestigation: 'Fire & Arson Investigation',
  firefightersafety: 'Firefighter Safety',
  other: 'Other',
  other2: 'Other 2',
  other3: 'Other 3',
  othercrr: 'Other Community Risk Reduction',
  othernational: 'Other National/State/Regional',
  adoptionawareness: 'Adoption or Awareness',
  wuieducationprogram: 'WUI Education and Awareness',
  wuieducationprogramwoodchipper: 'WUI Education and Awareness including Wood Chipper Program'
};
var camelCaseToSpaces = function camelCaseToSpaces(str) {
  if (LABEL_MAPPINGS[str] !== undefined) {
    return LABEL_MAPPINGS[str];
  }

  //known edge cases:
  switch (str) {
    case 'ppe':
      return 'PPE';
      break;
    case 'wellness':
      return 'Wellness and Fitness';
      break;
    case 'vehicle':
      return 'Vehicle Program';
      break;
    case 'modifyfacilities':
      return 'Modify Facilities';
      break;
    case 'equipment':
      return 'Equipment';
      break;
    case 'training':
      return 'Training';
      break;
    case 'fireandarsoninvestigation':
      return 'Fire & Arson Investigation';
      break;
    case 'programsandstudies':
      return 'National/State/Regional Programs and Studies';
      break;
    case 'communityriskreduction':
      return 'Community Risk Reduction';
      break;
    case 'hiringfirefighters':
      return 'Hiring of Firefighters';
      break;
    case 'recruitment':
      return 'Recruitment and Retention of Volunteer Firefighters';
      break;
    case 'researchanddevelopment':
      return 'Research and Development';
      break;
    case 'submittedToFEMA':
      return 'Submitted to FEMA';
      break;
    case undefined:
      return null;
      break;
  }
  var result = str.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};
exports.camelCaseToSpaces = camelCaseToSpaces;
var checkIfEmailIsFEMA = function checkIfEmailIsFEMA(email) {
  var femaEmails = ['@fema.dhs.gov', '@associates.fema.dhs.gov', '@dhs.gov', '@fema.gov', '@hq.dhs.gov', '@cbp.dhs.gov', '@associates.cisa.dhs.gov', '@cisa.dhs.gov', '@uscg.mil', '@associates.tsa.dhs.gov', '@tsa.dhs.gov', '@dot.gov'];
  for (var i = 0; i < femaEmails.length; i++) {
    if (email.indexOf(femaEmails[i]) !== -1) {
      return true;
    }
  }
  return false;
};
exports.checkIfEmailIsFEMA = checkIfEmailIsFEMA;
var checkIfEmailIsValid = function checkIfEmailIsValid(value) {
  var isvalid = false;
  if (value != null && value != undefined && value.match(_constants.email_regex)) {
    isvalid = true;
  }
  return isvalid;
};
exports.checkIfEmailIsValid = checkIfEmailIsValid;
var safeDivide = function safeDivide() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  var valueList = [].concat(values);
  var checkIfNum = function checkIfNum(val) {
    return !isNaN(parseFloat(val));
  };
  if (valueList.length === 0 || !_lodash.default.every(valueList, checkIfNum)) {
    return null;
  } else {
    valueList = _lodash.default.map(valueList, function (value) {
      return parseFloat(value);
    });
    var result = (0, _mathjs.bignumber)(valueList.shift());
    var _iterator2 = _createForOfIteratorHelper(valueList),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var value = _step2.value;
        result = (0, _mathjs.divide)(result, (0, _mathjs.bignumber)(value));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return (0, _mathjs.number)(result);
  }
};
exports.safeDivide = safeDivide;
var safeSubstract = function safeSubstract() {
  for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    values[_key2] = arguments[_key2];
  }
  var valueList = [].concat(values);
  var first = valueList.shift();
  return safeAdd.apply(void 0, [first].concat(_toConsumableArray(_lodash.default.map(valueList, function (value) {
    return -value;
  }))));
};

// Same as safeSubstract but calls safeAddNoFixed
exports.safeSubstract = safeSubstract;
var safeSubstractNoFixed = function safeSubstractNoFixed() {
  for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    values[_key3] = arguments[_key3];
  }
  var valueList = [].concat(values);
  var first = valueList.shift();
  return safeAddNoFixed.apply(void 0, [first].concat(_toConsumableArray(_lodash.default.map(valueList, function (value) {
    return -value;
  }))));
};
exports.safeSubstractNoFixed = safeSubstractNoFixed;
var safeMult = function safeMult() {
  for (var _len4 = arguments.length, values = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    values[_key4] = arguments[_key4];
  }
  var valueList = [].concat(values);
  var checkIfNum = function checkIfNum(val) {
    return !isNaN(parseFloat(val));
  };
  if (valueList.length === 0 || !_lodash.default.every(valueList, checkIfNum)) {
    return null;
  } else {
    valueList = _lodash.default.map(valueList, function (value) {
      return parseFloat(value);
    });
    var result = (0, _mathjs.bignumber)(valueList.pop());
    var _iterator3 = _createForOfIteratorHelper(valueList),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var value = _step3.value;
        result = (0, _mathjs.multiply)((0, _mathjs.bignumber)(value), result);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return (0, _mathjs.number)(result);
  }
};
exports.safeMult = safeMult;
var safeAdd = function safeAdd() {
  for (var _len5 = arguments.length, values = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    values[_key5] = arguments[_key5];
  }
  var valueList = [].concat(values);
  valueList = _lodash.default.map(valueList, function (value) {
    return !value || isNaN(value) ? 0 : parseFloat(value);
  });
  var result = 0;
  valueList.forEach(function (value) {
    return result += value;
  });
  return parseFloat(result.toFixed(2));
};

// Same as safeAdd but does not format a number using fixed-point notation
exports.safeAdd = safeAdd;
var safeAddNoFixed = function safeAddNoFixed() {
  for (var _len6 = arguments.length, values = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    values[_key6] = arguments[_key6];
  }
  var valueList = [].concat(values);
  valueList = _lodash.default.map(valueList, function (value) {
    return !value || isNaN(value) ? 0 : parseFloat(value);
  });
  // When adding numbers with decimal parts, Javascript may add extra decimals
  // To avoid this multiplying numbers by 1000000 before adding and then dividing by that
  // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
  var multiplicator = 1000000;
  var result = 0;
  valueList.forEach(function (value) {
    return result += (0, _mathjs.multiply)(value, multiplicator);
  });
  return parseFloat((0, _mathjs.divide)(result, multiplicator));
};
exports.safeAddNoFixed = safeAddNoFixed;
var safeAddReduce = function safeAddReduce(valueList, base) {
  return _lodash.default.reduce(valueList, function (currTotal, value) {
    return safeAdd(currTotal, value);
  }, base);
};
exports.safeAddReduce = safeAddReduce;
var hasChildren = function hasChildren(obj) {
  return obj.children !== undefined && !_lodash.default.isEmpty(obj.children);
};
exports.hasChildren = hasChildren;
var isStringEmpty = function isStringEmpty(text) {
  if (_lodash.default.isString(text)) {
    text = text.replace(/ /g, '');
    text = text.replace(/\t/g, '');
    text = text.replace(/\n/g, '');
  }
  if (text === '') {
    return true;
  }
  return false;
};

// preemptively listing more filetypes than we support
// to avoid later work since this is just for icon displaying
exports.isStringEmpty = isStringEmpty;
var iconFromExtension = function iconFromExtension(type) {
  var lowercaseType = type.toLowerCase();
  var namePrefix = 'file ';
  var name;
  var color;
  switch (lowercaseType) {
    case 'pdf':
      name = 'pdf';
      color = 'red';
      break;
    case 'doc':
    case 'docx':
      name = 'word';
      color = 'blue';
      break;
    case 'xls':
    case 'xlsx':
      name = 'excel';
      color = 'green';
      break;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      name = 'image';
      color = 'black';
      break;
    case 'ppt':
    case 'pptx':
      name = 'powerpoint';
      color = 'red';
      break;
    default:
      name = 'alternate';
      color = 'grey';
  }
  return {
    name: namePrefix + name,
    color: color
  };
};
exports.iconFromExtension = iconFromExtension;
var getExtension = function getExtension(fileName) {
  var fileNameParts = fileName.split('.');
  // Assuming we want empty string if the name has no extension
  var extension = fileNameParts.length > 1 ? fileNameParts.pop() : '';
  return extension;
};
exports.getExtension = getExtension;
var getNumberFromObject = function getNumberFromObject(obj, path) {
  var value = _lodash.default.get(obj, path, 0);
  if (!_lodash.default.isNumber(value)) {
    value = 0;
  }
  return value;
};
exports.getNumberFromObject = getNumberFromObject;
var requestDetailsChangesToDisplayString = function requestDetailsChangesToDisplayString(change, index) {
  var type = change.type;
  var message = /*#__PURE__*/_react.default.createElement("span", null);
  var formatValue = function formatValue(value, formatType) {
    var valueOrDefault = value !== undefined ? value : '';
    return /*#__PURE__*/_react.default.createElement("strong", null, formatType === 'dollar' ? "".concat(formatDollarOrEmptyString(valueOrDefault)) : valueOrDefault);
  };
  switch (type) {
    case _constants.REQUEST_DETAILS_CHANGES_TYPES.VALUE_CHANGE:
      var prev = formatValue(change.previousValue, change.formatType);
      var curr = formatValue(change.currValue, change.formatType);
      message = /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("strong", null, _constants.REQUEST_DETAILS_VALUE_CHANGE_DISPLAY[change.field]), ' from ', prev, ' to ', curr);
      break;
    case _constants.REQUEST_DETAILS_CHANGES_TYPES.INELIGIBLE_CHANGE:
      message = /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("strong", null, "Line item"), ' marked ', /*#__PURE__*/_react.default.createElement("strong", null, change.becameIneligible ? 'ineligible' : 'eligible'));
      break;
    case _constants.REQUEST_DETAILS_CHANGES_TYPES.NEWLY_CREATED:
      message = /*#__PURE__*/_react.default.createElement("strong", null, "Line item created");
      break;
    case _constants.REQUEST_DETAILS_CHANGES_TYPES.VALUE_CHANGE_NO_DISPLAY:
      message = /*#__PURE__*/_react.default.createElement("strong", null, _constants.REQUEST_DETAILS_VALUE_CHANGE_DISPLAY[change.field], ' changed');
      break;
    default:
      break;
  }
  return message;
};
exports.requestDetailsChangesToDisplayString = requestDetailsChangesToDisplayString;
var isToggledOnDependency = function isToggledOnDependency(toggle, toggleList, entityType, entityId) {
  return toggle ? _lodash.default.find(toggleList, function (curr) {
    return matchesToggle(toggle, curr, entityType, entityId);
  }) !== undefined : true;
};
exports.isToggledOnDependency = isToggledOnDependency;
var countDependenciesToLoad = function countDependenciesToLoad(dependencies, isFema, toggles, entityType, entityId) {
  var count = 0;
  _lodash.default.forEach(dependencies, function (dependency) {
    var dependencyToggle = _lodash.default.get(dependency, 'dependencyConfig.toggle.name', false);
    var isToggledOnDependencyFlag = isToggledOnDependency(dependencyToggle, toggles, entityType, entityId);
    // this also needs another condition for negated toggles e.g. "ifNot". Maybe like dependencyConfig.toggleIfNot
    if (isToggledOnDependencyFlag) {
      if (_lodash.default.get(dependency, 'dependencyConfig.femaPermissionsOnly')) {
        if (isFema && !dependency.optional) {
          count += 1;
        }
      } else if (!dependency.optional) {
        count += 1;
      }
    }
  });
  return count;
};
exports.countDependenciesToLoad = countDependenciesToLoad;
var calculatePaymentDispursements = function calculatePaymentDispursements(data) {
  var fedTotal = 0;
  var pendingTotal = 0;
  var totals = [];
  _lodash.default.forEach(data, function (payment) {
    if (payment.payload != undefined) {
      if (payment.status === 'approved') {
        fedTotal = safeAdd(payment.payload.amount, fedTotal);
      }
      if (payment.status === 'submittedToFEMA') {
        pendingTotal = safeAdd(payment.payload.amount, pendingTotal);
      }
    }
  });
  totals.federalDispursements = fedTotal;
  totals.pendingDispursements = pendingTotal;
  return totals;
};
exports.calculatePaymentDispursements = calculatePaymentDispursements;
var calculatePaymentFederalBalance = function calculatePaymentFederalBalance(data, fedShare) {
  var fedDispursements = 0;
  var pendingDispursements = 0;
  var totalFedAvail = 0;
  var fedResourcesAwarded = 0;
  if (_typeof(fedShare) === 'object') {
    fedResourcesAwarded = safeAdd.apply(void 0, _toConsumableArray(fedShare));
  } else {
    fedResourcesAwarded = _lodash.default.toNumber(fedShare);
  }
  if (data != undefined) {
    fedDispursements = calculatePaymentDispursements(data).federalDispursements;
    pendingDispursements = calculatePaymentDispursements(data).pendingDispursements;
    totalFedAvail = safeSubstractNoFixed(fedResourcesAwarded, safeAddNoFixed(fedDispursements, pendingDispursements));
  }
  return totalFedAvail;
};
exports.calculatePaymentFederalBalance = calculatePaymentFederalBalance;
var calculateBOCAggregates = function calculateBOCAggregates(data, bocList) {
  var totals = _lodash.default.map(bocList, function (boc) {
    return {
      boc: boc,
      total: 0
    };
  });
  _lodash.default.forEach(data.preAwardCosts, function (cost) {
    var costBoc = cost.boc;
    var matchIndex = _lodash.default.findIndex(totals, ['boc', costBoc]);
    if (matchIndex >= 0 && !cost.ineligible) {
      _lodash.default.set(totals, [matchIndex, 'total'], safeAdd(_lodash.default.get(totals, [matchIndex, 'total'], 0), safeMult(cost.price * cost.quantity)));
    }
  });
  _lodash.default.forEach(data.activityItems, function (firstTier) {
    var additional = _lodash.default.get(firstTier, 'additionalRequests');
    var children = _lodash.default.get(firstTier, 'children');
    _lodash.default.forEach(additional, function (funding) {
      var fundingBoc = funding.boc;
      var matchIndex = _lodash.default.findIndex(totals, ['boc', fundingBoc]);
      if (matchIndex >= 0 && !funding.ineligible) {
        _lodash.default.set(totals, [matchIndex, 'total'], safeAdd(_lodash.default.get(totals, [matchIndex, 'total'], 0), funding.amount));
      }
    });
    _lodash.default.forEach(children, function (secondTier) {
      var secondBoc = secondTier.boc;
      var matchIndex = _lodash.default.findIndex(totals, ['boc', secondBoc]);
      if (matchIndex >= 0 && !secondTier.ineligible) {
        _lodash.default.set(totals, [matchIndex, 'total'], safeAdd(_lodash.default.get(totals, [matchIndex, 'total'], 0), safeMult(secondTier.price, secondTier.quantity)));
      }
      _lodash.default.forEach(secondTier.children, function (thirdTier) {
        var thirdBoc = thirdTier.boc;
        var thirdMatchIndex = _lodash.default.findIndex(totals, ['boc', thirdBoc]);
        if (thirdMatchIndex >= 0 && !thirdTier.ineligible) {
          _lodash.default.set(totals, [thirdMatchIndex, 'total'], safeAdd(_lodash.default.get(totals, [thirdMatchIndex, 'total'], 0), safeMult(thirdTier.price, thirdTier.quantity)));
        }
      });
    });
  });
  var totalsTotal = 0;
  totals = _lodash.default.map(totals, function (bocTotal) {
    bocTotal.boc = toStartCase(bocTotal.boc);
    totalsTotal += bocTotal.total;
    return "".concat(bocTotal.boc, "-").concat(bocTotal.total);
  });
  totals.push("Total-".concat(totalsTotal));
  return totals;
};

// lodash startCase removes special characters such as parenthesis
exports.calculateBOCAggregates = calculateBOCAggregates;
var toStartCase = function toStartCase(text) {
  if (!checkIfValuesAre(['', null, undefined], text)) {
    return text.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1);
    });
  }
  return text;
};
exports.toStartCase = toStartCase;
var formatDollarOrEmptyString = function formatDollarOrEmptyString(value) {
  return value !== undefined ? showDollarAmountWithDollar(value) : '';
};
exports.formatDollarOrEmptyString = formatDollarOrEmptyString;
var addBusinessDays = function addBusinessDays(value, numberOfDays) {
  _momentBusinessDays.default.updateLocale('us', {
    holidays: _constants.HOLIDAYS,
    holidayFormat: 'MM-DD-YYYY'
  });
  var addedDate = (0, _momentBusinessDays.default)(value).businessAdd(numberOfDays).format();
  return addedDate;
};
exports.addBusinessDays = addBusinessDays;
var setTime = function setTime(date, hours, minutes) {
  var momentDate = (0, _momentTimezone.default)(date).hour(hours || 0).minute(minutes || 0);
  return momentDate.format();
};
exports.setTime = setTime;
var compileContent = function compileContent(content, ctx, parseHtml, templateAsArray) {
  var compiledContent = content;
  try {
    // Only compile when need to
    if (typeof content === 'string' && (content.indexOf('<%') > -1 || content.indexOf('${') > -1 || parseHtml)) {
      // merge our utility function context with the variables provided by the component
      var newCtx = _objectSpread(_objectSpread({}, ctx), TEMPLATE_CONTEXT);
      compiledContent = _lodash.default.template(content)(newCtx);
      if (templateAsArray) {
        compiledContent = compiledContent.split(templateAsArray);
      }
      if (parseHtml) {
        // we don't want to do this generally, just when safe to avoid rendering
        // user input as HTML
        compiledContent = (0, _reactHtmlParser.default)(compiledContent);
      }
    }
  } catch (err) {
    if (content !== _constants.SUB_AWARD_REC_INDX_ERROR) {
      console.error(err);
    }
    compiledContent = '';
  }
  return compiledContent;
};
exports.compileContent = compileContent;
var PHONE_TYPE_OPTIONS = {
  1: 'Alternate',
  2: 'Car',
  3: 'Work Fax',
  4: 'Home',
  5: 'Lodging',
  6: 'Mobile',
  7: 'Other',
  8: 'Pager',
  9: 'Receptionist',
  10: 'Work',
  11: 'Home Fax',
  12: 'Lodging Fax'
};
var _newlyAddedDisasterLocationNames = function newlyAddedDisasterLocationNames(options, prevDate) {
  if (options && prevDate) {
    var filterOptions = _lodash.default.filter(options, function (item) {
      return (0, _momentTimezone.default)(item.entryDt, 'YYYY-MM-DD').isAfter((0, _momentTimezone.default)(prevDate));
    });
    var optionStrings = _lodash.default.map(filterOptions, function (item) {
      return item.placeNm;
    });
    return _lodash.default.join(optionStrings);
  }
  return '';
};
exports.newlyAddedDisasterLocationNames = _newlyAddedDisasterLocationNames;
var gatherPhoneList = function gatherPhoneList(inPhoneList) {
  var outPhonesList = [];
  outPhonesList = _lodash.default.map(inPhoneList, function (phone) {
    return {
      phoneType: PHONE_TYPE_OPTIONS[phone.phoneType] ? PHONE_TYPE_OPTIONS[phone.phoneType] : 'Unknown',
      phoneNumber: displayPhoneNumber(phone.areaCode, phone.phoneNumber),
      phoneExt: phone.phoneExtension
    };
  });
  return outPhonesList;
};

/** SHORTHAND FUNCTIONS FOR USE IN CONFIG DATA TEMPLATES **/
exports.gatherPhoneList = gatherPhoneList;
var templateUtility = {
  formatStringOrMilliToDate: function formatStringOrMilliToDate(value) {
    return convertDateForDisplay(value, true);
  },
  formatStringOrMilliToDateWithTimeZone: function formatStringOrMilliToDateWithTimeZone(value, timezone) {
    return convertDateWithTimezoneForDisplay(value, timezone, true);
  },
  toBoldHTML: function toBoldHTML(value) {
    return "<strong>".concat(value, "</strong>");
  },
  toYesNo: function toYesNo(value) {
    return value ? 'Yes' : 'No';
  },
  percentOrDash: function percentOrDash(value) {
    return "".concat(value || '-', "%");
  }
};

/** Function name context that config "template" fields will have access to **/
var TEMPLATE_CONTEXT = {
  add: safeAdd,
  addReduce: safeAddReduce,
  subtract: safeSubstract,
  divide: safeDivide,
  multiply: safeMult,
  addArray: function addArray(arr) {
    return safeAdd.apply(void 0, _toConsumableArray(arr));
  },
  getTimestampNowISO: getTimestampNowISO,
  getTimestampOfISO: getTimestampOfISO,
  formatDate: templateUtility.formatStringOrMilliToDate,
  formatDateForTimeZone: templateUtility.formatStringOrMilliToDateWithTimeZone,
  addBusinessDays: addBusinessDays,
  setTime: setTime,
  formatDollar: formatDollarOrEmptyString,
  currentYear: function currentYear(addOrSubtract) {
    return CurrentYear(addOrSubtract);
  },
  arrAttrSum: function arrAttrSum(data, attributes) {
    return _arrAttrSum({
      array: data,
      attributes: attributes
    });
  },
  sumOfJsonPathArray: function sumOfJsonPathArray(data, jsonPathPattern, arrayIndex) {
    return SumOfJsonPathArray(data, jsonPathPattern, arrayIndex);
  },
  isoToDisplayDate: function isoToDisplayDate(value) {
    return ISOToDisplayDate(value, {
      showDate: true,
      showHours: false
    });
  },
  isoToDisplayDateAndTimeWithZone: function isoToDisplayDateAndTimeWithZone(value) {
    return ISOToDisplayDate(value, {
      showDate: true,
      showHours: true,
      showTimeZone: true
    });
  },
  isoToDisplayDateFormat: function isoToDisplayDateFormat(value) {
    return (0, _momentTimezone.default)(value).utc().format('MM/DD/YYYY');
  },
  isoToDisplayTime: function isoToDisplayTime(value) {
    return ISOToDisplayDate(value, {
      showDate: false,
      showHours: true
    });
  },
  isoToDisplayDateAndTime: function isoToDisplayDateAndTime(value) {
    return ISOToDisplayDate(value, {
      showDate: true,
      showHours: true
    });
  },
  formatPercentage: showPercentageAmountWithPercentage,
  bold: templateUtility.toBoldHTML,
  toYesNo: templateUtility.toYesNo,
  gatherPhoneList: gatherPhoneList,
  percentOrDash: templateUtility.percentOrDash,
  statusFormatter: function statusFormatter(status) {
    return _lodash.default.get(_constants.PREAWARD_STATUSES, status, _lodash.default.get(_constants.ASSOCIATED_ENTITY_STATUSES, status, _lodash.default.get(_constants.PREAWARD_STATUSES, _constants.STATUS_SUBMITTED_TO_FEMA)));
  },
  calculateBOCAggregates: calculateBOCAggregates,
  calculatePaymentDispursements: calculatePaymentDispursements,
  calculatePaymentFederalBalance: calculatePaymentFederalBalance,
  phoneTypeProfileToContacts: phoneTypeProfileToContacts,
  //getItemCost: calculateItemCostTotal,
  //countQuantityOfItem,
  _: _lodash.default,
  ASSOCIATED_ENTITY_STATUSES: _constants.ASSOCIATED_ENTITY_STATUSES,
  getBudgetGrandTotal: function getBudgetGrandTotal(fundingStreams, mode) {
    return calculateTotalFundingStreams({
      fundingStreams: fundingStreams,
      mode: mode
    });
  },
  isProgramExternal: isProgramExternal,
  toStartCase: toStartCase,
  getPanelStatusAlias: function getPanelStatusAlias(status) {
    return _lodash.default.get(_constants.PANEL_STATUS_CHANGE_DISPLAY, status);
  },
  newlyAddedDisasterLocationNames: function newlyAddedDisasterLocationNames(options, prevDate) {
    return _newlyAddedDisasterLocationNames(options, prevDate);
  },
  formatUEIname: function formatUEIname(data) {
    var eft = _lodash.default.trim(_lodash.default.get(data, 'eft'));
    return _lodash.default.get(data, 'uei') + (!_lodash.default.isEmpty(eft) ? '-' + eft : '');
  },
  applicationStartDate: function applicationStartDate(date) {
    return getYear(date);
  }
};
var contains = function contains(collection, value) {
  return _lodash.default.indexOf(collection, value) > -1;
};
exports.contains = contains;
var shouldDisplayByRequestDetailsTotal = function shouldDisplayByRequestDetailsTotal(data, value) {
  var matchBy = value.matchBy,
    mode = value.mode,
    itemCode = value.itemCode;
  var calculatedTotal = 0;
  _lodash.default.forEach(data, function (child) {
    var children = _lodash.default.get(child, 'children', {});
    _lodash.default.filter(children, function (item) {
      if (item.itemCode === itemCode) {
        calculatedTotal = calculateChildrenTotalByMode(item.children, mode);
      }
    });
  });
  var isValid = _lodash.default.toNumber(calculatedTotal) > _lodash.default.toNumber(matchBy);
  return isValid;
};
var calculateTotalFundingStreams = function calculateTotalFundingStreams(_ref) {
  var fundingStreams = _ref.fundingStreams,
    mode = _ref.mode;
  var total = safeAddReduce(_lodash.default.map(fundingStreams, function (stream) {
    return calculateChildrenTotalByMode(stream.children, mode);
  }), 0);
  return total;
};
exports.calculateTotalFundingStreams = calculateTotalFundingStreams;
var fetchPhaseArray = function fetchPhaseArray(data) {
  var phaseArray = [];
  _lodash.default.forEach(data, function (child) {
    var children = _lodash.default.get(child, 'children', {});
    _lodash.default.forEach(children, function (item) {
      var itemCodeCostTypeID = _lodash.default.get(item, 'itemCode');
      var costItems = _lodash.default.get(item, 'children');
      _lodash.default.forEach(costItems, function (item) {
        phaseArray.push(item.cost[0][0].phasedProject);
      });
    });
  });
  return phaseArray;
};
exports.fetchPhaseArray = fetchPhaseArray;
var isPreAwardPhaseProject = function isPreAwardPhaseProject(data, notApplicable) {
  var flag = false;
  _lodash.default.forEach(data, function (child) {
    var children = _lodash.default.get(child, 'children', {});
    _lodash.default.forEach(children, function (item) {
      var itemCodeCostTypeID = _lodash.default.get(item, 'itemCode');
      var costItems = _lodash.default.get(item, 'children');
      _lodash.default.forEach(costItems, function (item) {
        if (item.cost[0][0].phasedProject === notApplicable && item.cost[0][0].preAward !== true) {
          flag = true;
        } else if ((item.cost[0][0].phasedProject === undefined || item.cost[0][0].phasedProject !== notApplicable) && item.cost[0][0].preAward === true) {
          flag = true;
        }
      });
    });
  });
  return flag;
};
var runCostEstimatePhasedProjectRule = function runCostEstimatePhasedProjectRule(data, value) {
  var phase1 = value.phase1,
    phase2 = value.phase2,
    notApplicable = value.notApplicable;
  var scopeOfWork = data.scopeOfWork,
    fundingStreams = data.fundingStreams;
  var phasedProject = scopeOfWork.phasedProject;
  var isPhasedProject = phasedProject;
  var phaseArray = fetchPhaseArray(fundingStreams);
  var isValid = false;
  if (isPhasedProject === 'Yes' && phaseArray.length > 0) {
    if (!phaseArray.includes(phase1) || !phaseArray.includes(phase2)) {
      isValid = true;
    }
  }
  return isValid;
};
exports.runCostEstimatePhasedProjectRule = runCostEstimatePhasedProjectRule;
var getPanelStatusAlias = function getPanelStatusAlias(status) {
  console.log(status);
  return _lodash.default.get(_constants.PANEL_STATUS_CHANGE_DISPLAY, status);
};
exports.getPanelStatusAlias = getPanelStatusAlias;
var runCostEstimatePreAwardPhasedProjectRule = function runCostEstimatePreAwardPhasedProjectRule(data, value) {
  var notApplicable = value.notApplicable;
  var fundingStreams = data.fundingStreams;
  return isPreAwardPhaseProject(fundingStreams, notApplicable);
};
exports.runCostEstimatePreAwardPhasedProjectRule = runCostEstimatePreAwardPhasedProjectRule;
var evaluateOperator = function evaluateOperator(operator, firstVal, secondVal, typeVal, extraProps) {
  var result = false;
  switch (operator) {
    case 'equal':
      result = _lodash.default.isEqual(firstVal, secondVal);
      break;
    case 'notEqual':
      result = !_lodash.default.isEqual(firstVal, secondVal);
      break;
    case 'lessThanOrEqualTo':
      result = _lodash.default.toNumber(firstVal) <= _lodash.default.toNumber(secondVal);
      break;
    case 'arrayLessThanOrEqualTo':
      result = _lodash.default.sum(_lodash.default.toNumber(firstVal)) <= _lodash.default.toNumber(secondVal);
      break;
    case 'greaterThan':
      result = _lodash.default.toNumber(firstVal) > _lodash.default.toNumber(secondVal);
      break;
    case 'greaterThanOrEqualTo':
      result = _lodash.default.toNumber(firstVal) >= _lodash.default.toNumber(secondVal);
      break;
    case 'arrayGreaterThan':
      result = _lodash.default.toNumber(firstVal.reduce(function (a, b) {
        return a + b;
      }, 0)) > _lodash.default.toNumber(secondVal);
      break;
    case 'lengthGreaterThan':
      result = firstVal ? _lodash.default.size(firstVal) > secondVal : false;
      break;
    case 'lengthLessThan':
      result = firstVal ? _lodash.default.size(firstVal) < secondVal : false;
      break;
    case 'isFemaUser':
      result = isFemaUser(firstVal) === secondVal;
      break;
    case 'isProgramExternal':
      result = isProgramExternal(firstVal) === secondVal;
      break;
    case 'isFemaOrProgramExternal':
      result = isFemaOrProgramExternal(firstVal) === secondVal;
      break;
    case 'hasBankingPermissions':
      result = hasBankingPermissions(firstVal) === secondVal;
      break;
    case 'equalsAnyValue':
      result = secondVal.includes(firstVal);
      break;
    case 'notequalsAnyValue':
      result = !secondVal.includes(firstVal);
      break;

    // This is similar with 'equalsAnyValue', but it expects the first operand as a list
    case 'isValueInList':
      result = _lodash.default.includes(firstVal, secondVal);
      break;
    case 'isNotValueInList':
      result = !firstVal.includes(secondVal);
      break;
    case 'isValueInObjectList':
      if (firstVal && _lodash.default.find(firstVal, function (option) {
        return option[secondVal.fieldName] == secondVal.value;
      })) {
        result = true;
      }
      break;
    case 'costBocV1':
      result = costBocV1(firstVal, typeVal) === secondVal;
      break;
    case 'costBocV2':
      result = costBocV2(firstVal, typeVal) === secondVal;
      break;
    case 'grantType':
      result = grantType(firstVal, typeVal) === secondVal;
      break;
    case 'totalGreaterThanZero':
      result = totalGreaterThanZero(firstVal) === secondVal;
      break;
    case 'hasGrantWriterFee':
      result = hasGrantWriterFee(firstVal) === secondVal;
      break;
    case 'isMissingHiringPosition':
      result = !isMissingHiringPosition(firstVal, typeVal) === secondVal;
      break;
    case 'arrAttrSumGreaterThan':
      result = _arrAttrSum({
        array: firstVal,
        attributes: typeVal
      }) > secondVal;
      break;
    case 'arrAttrSumLessThanOrEqualTo':
      result = _arrAttrSum({
        array: firstVal,
        attributes: typeVal
      }) <= secondVal;
      break;
    case 'checkIfOneValue':
      _lodash.default.forEach(typeVal, function (fields, index) {
        var question = _lodash.default.get(firstVal, fields);
        if (question !== undefined) {
          _lodash.default.forEach(secondVal, function (value, index) {
            if (question.response === value) {
              result = true;
            }
          });
        }
      });
      break;
    case 'isEmpty':
      result = _lodash.default.isEmpty(firstVal) === secondVal;
      break;
    case 'hasItemOfCostType':
      result = hasItemOfCostType(firstVal, typeVal) === secondVal;
      break;
    case 'hasRoles':
      result = PermissionChecks.compareRolesAndPermissions(secondVal, firstVal) === typeVal;
      break;
    case 'hasRolesForRequestForInfo':
      result = rfiSectionCheck(firstVal, _lodash.default.get(extraProps, 'entityId'), _lodash.default.get(extraProps, 'subOrgId')) === typeVal;
      break;
    case 'hasRolesForTheOrg':
      result = PermissionChecks.compareRolesAndPermissionsForEntity(secondVal, firstVal, _lodash.default.get(extraProps, 'entityId')) === typeVal;
      break;
    case 'hasRolesForOrgProgram':
      result = PermissionChecks.compareRolesAndProgramsForEntity(secondVal, firstVal, _lodash.default.get(extraProps, 'entityId'), _lodash.default.get(extraProps, 'context.grant.programId')) === typeVal;
      break;
    case 'isSAR':
      result = PermissionChecks.compareRolesAndPermissions([_constants.ROLE_MAP.SUBAUTHREP.code], firstVal) === typeVal;
      break;
    case 'isSARorSM':
      result = PermissionChecks.compareRolesAndPermissions([_constants.ROLE_MAP.SUBAUTHREP.code, _constants.ROLE_MAP.SUBMEMBER.code], firstVal) === typeVal;
      break;
    case 'isAORorAOorPSorFMorOMorPMorPA':
      result = PermissionChecks.compareRolesAndPermissions([_constants.ROLE_MAP.ORGAOR.code, _constants.ROLE_MAP.PGMAO.code, _constants.ROLE_MAP.PGMPS.code, _constants.ROLE_MAP.ORGFINMEMBER.code, _constants.ROLE_MAP.ORGMEMBER.code, _constants.ROLE_MAP.ORGFINMEMBER.code, _constants.ROLE_MAP.PGMADMIN.code, _constants.ROLE_MAP.SPGMADMIN.code], firstVal) === typeVal;
      break;
    case 'shouldDisplayByRequestDetailsTotal':
      result = shouldDisplayByRequestDetailsTotal(firstVal, secondVal);
      break;
    case 'runCostEstimatePhasedProjectRule':
      result = runCostEstimatePhasedProjectRule(firstVal, secondVal);
      break;
    case 'runCostEstimatePreAwardPhasedProjectRule':
      result = runCostEstimatePreAwardPhasedProjectRule(firstVal, secondVal);
      break;
    // case 'countHiringOfFirefighterPaymentsGreaterThan':
    //   result = countHiringOfFirefighterPaymentsGreaterThan(firstVal) > secondVal;
    //   break;
    case 'dateIsSameOrAfterWithRestriction':
      var secondDate = _lodash.default.get(extraProps, secondVal);
      if (firstVal && secondDate) {
        result = (0, _momentTimezone.default)(firstVal).isSameOrAfter(secondDate);
        var noMoreThanDaysInFuture = _lodash.default.get(extraProps, 'noMoreThanDaysInFuture');
        if (result && noMoreThanDaysInFuture) {
          result = (0, _momentTimezone.default)(firstVal).diff((0, _momentTimezone.default)(), 'days') < noMoreThanDaysInFuture;
        }
      } else {
        result = false;
      }
      break;
    case 'duplicatePhoneNumbers':
      result = duplicatePhoneNumbers(firstVal) === secondVal;
      break;
    case 'lessThanTwoUniquePhoneNumbers':
      result = lessThanTwoUniquePhoneNumbers(firstVal) === secondVal;
      break;
    case 'duplicateEmails':
      result = duplicateEmails(firstVal, secondVal) === true;
      break;
    case 'isNewDisasterLocationAdded':
      result = isNewDisasterLocationAdded(firstVal, secondVal);
      break;
    case 'isFOIDinToggleList':
      var entityType = _lodash.default.get(extraProps, 'context.grant.fundingOpportunityId');
      result = _lodash.default.includes(firstVal, "fundingOpportunity-".concat(entityType, "-").concat(secondVal));
      break;
    default:
      result = _lodash.default.get(PermissionChecks, operator, false) ? PermissionChecks[operator](firstVal) === secondVal : false;
  }
  return result;
};
exports.evaluateOperator = evaluateOperator;
var hasGrantWriterFee = function hasGrantWriterFee(fundingStreams) {
  var fundingStream = _lodash.default.find(fundingStreams, function (stream) {
    return stream.fundingStreamType === 'preAwardCosts';
  });
  if (fundingStream) {
    if (searchChildren(fundingStream.children)) {
      return true;
    }
  }
  return false;
};
exports.hasGrantWriterFee = hasGrantWriterFee;
var searchChildren = function searchChildren(children) {
  var hasGrantWritingFee = false;
  _lodash.default.forEach(children, function (child) {
    if (!hasGrantWritingFee) {
      hasGrantWritingFee = _lodash.default.isEqual(child.itemCode, 48) || searchChildren(child.children);
    }
  });
  return hasGrantWritingFee;
};
var isMissingHiringPosition = function isMissingHiringPosition(fundingStreams, itemCodes) {
  var fundingStream = _lodash.default.find(fundingStreams, function (stream) {
    return stream.fundingStreamType === 'hiringOfFirefighters';
  });
  if (fundingStream) {
    if (searchChildrens(fundingStream.children, itemCodes)) {
      return true;
    }
  }
  return false;
};
exports.isMissingHiringPosition = isMissingHiringPosition;
var searchChildrens = function searchChildrens(fundingStreams, itemCodes) {
  var hasChildren = false;
  _lodash.default.forEach(fundingStreams, function (stream) {
    _lodash.default.forEach(stream.children, function (child) {
      if (!hasChildren) {
        hasChildren = _lodash.default.includes(itemCodes, child.itemCode) || searchChildrens(child.children);
      }
    });
  });
  return hasChildren;
};
var totalGreaterThanZero = function totalGreaterThanZero(costValues) {
  var total = 0;
  _lodash.default.forEach(costValues, function (costValue) {
    return total = safeAdd(total, costValue);
  });
  if (total > 0) {
    return true;
  }
  return false;
};
exports.totalGreaterThanZero = totalGreaterThanZero;
var costBocV1 = function costBocV1(budgetSummary, typeVal) {
  if (_lodash.default.find(budgetSummary, function (item) {
    return _lodash.default.trim(item.boc) === typeVal && item.total > 0;
  })) {
    return true;
  }
  return false;
};
exports.costBocV1 = costBocV1;
var costBocV2 = function costBocV2(budgetSummary, typeVal) {
  if (_lodash.default.find(budgetSummary, function (item, key) {
    return key === _lodash.default.camelCase(_lodash.default.trim(typeVal)) && _lodash.default.sum(item) > 0;
  })) {
    return true;
  }
  return false;
};
exports.costBocV2 = costBocV2;
var arrSumAsNumber = function arrSumAsNumber(array) {
  var sum = 0;
  for (var i = 0; i < array.length; i++) {
    sum = sum + Number(array[i]);
  }
  return sum;
};
exports.arrSumAsNumber = arrSumAsNumber;
var _arrAttrSum = function _arrAttrSum(data) {
  var sum = 0;
  if (data) {
    if (data.array) {
      var arrayData = data.array;
      if (data.attributes) {
        var attributes = data.attributes;
        for (var i = 0; i < attributes.length; i++) {
          var attribute = attributes[i];
          var attributeValues = _jsonpath.default.query(arrayData, attribute);
          sum = sum + arrSumAsNumber(attributeValues);
        }
      }
    }
  }
  return sum;
};
exports.arrAttrSum = _arrAttrSum;
var grantType = function grantType(fundingStreams, typeVal) {
  if (_lodash.default.find(fundingStreams, function (item) {
    return _lodash.default.trim(item.fundingStreamType) === typeVal;
  })) {
    return true;
  }
  return false;
};
exports.grantType = grantType;
var buildBookmarkLink = function buildBookmarkLink(props) {
  var parseAll = props.parseAll;
  var content = props.content;
  var contentToRender = [];
  _lodash.default.forEach(props.links, function (link, index) {
    var onClick = function onClick(e) {
      if (props.setCurrentFieldList) {
        props.setCurrentFieldList(link.location);
      }
    };
    var contentParts = _lodash.default.split(content, "<a>".concat(link.text, "</a>"));
    content = _lodash.default.replace(content, contentParts[0], '');
    content = _lodash.default.replace(content, "<a>".concat(link.text, "</a>"), '');
    var linkCode = /*#__PURE__*/_react.default.createElement("a", {
      href: link.href,
      onClick: onClick,
      title: link.text
    }, link.text);
    var firstPart = _lodash.default.get(contentParts, 0, '');
    contentToRender.push( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, parseAll ? (0, _reactHtmlParser.default)(firstPart) : firstPart, linkCode));
  });
  contentToRender.push( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: "content"
  }, parseAll ? (0, _reactHtmlParser.default)(content) : content));
  return contentToRender;
};
exports.buildBookmarkLink = buildBookmarkLink;
var calculateLastNonZeroBudgetPeriod = function calculateLastNonZeroBudgetPeriod(fedShareByPeriod) {
  return _lodash.default.findLastIndex(fedShareByPeriod, function (fedShare) {
    return fedShare > 0;
  }) + 1;
};
exports.calculateLastNonZeroBudgetPeriod = calculateLastNonZeroBudgetPeriod;
var calculatePOPEndDate = function calculatePOPEndDate(programId, fundingStreams, numPeriods, startDate) {
  var endDate = null;
  if (programId == 10) {
    endDate = (0, _momentTimezone.default)(startDate).add(12, 'month');
  } else if (programId == 11) {
    var fundingStreamTypes = _lodash.default.map(fundingStreams, function (stream) {
      return _lodash.default.get(stream, 'fundingStreamType', '');
    });
    if (_lodash.default.includes(fundingStreamTypes, _constants.RECRUITMENT_AND_RETENTION)) {
      endDate = (0, _momentTimezone.default)(startDate).add(12 * numPeriods, 'month');
    } else if (_lodash.default.includes(fundingStreamTypes, _constants.HIRING_OF_FIREFIGHTERS)) {
      endDate = (0, _momentTimezone.default)(startDate).add(36, 'month');
    }
  } else if (programId === 12) {
    endDate = (0, _momentTimezone.default)(startDate).add(12 * numPeriods, 'month');
  }
  return endDate != null ? endDate.subtract(1, 'day') : endDate;
};
// export const calculateProgramArea = (programId, grantId, fundingStreamsJson) => {
//   const fundingStreams = JSON.parse(fundingStreamsJson || '[]');
//   return _.join(
//     _.map(
//       _.filter(fundingStreams, (stream) => stream !== 'preAwardCosts'),
//       (streamKey) => FUNDING_STREAM_NAME[streamKey]
//     ),
//     ','
//   ); // only one item in blacklist for now
// };
//moved it from TaskSchedule to utils
exports.calculatePOPEndDate = calculatePOPEndDate;
var modalVal = function modalVal(props) {
  var validationErrors = props.validationErrors,
    validationDirtyMap = props.validationDirtyMap;

  // Find errors associated with a specific field name.
  var findError = function findError(field) {
    var errs = _lodash.default.get(_lodash.default.get(validationErrors, 0), field);
    if (errs instanceof Array) {
      return _lodash.default.find(errs, function (err) {
        return !err.isValid;
      });
    }
    return errs;
  };

  // Determine whether a specific field is valid (has any errors).
  var displayError = function displayError(field) {
    return _lodash.default.get(findError(field), 'isValid') === false;
  };

  // Grab the error message associated with a specific field.
  var errorMessage = function errorMessage(field) {
    return _lodash.default.get(findError(field), 'message');
  };

  // Determine whether a specific field has been touched.
  var isDirty = function isDirty(field) {
    // If a dirty map entry for the field exists, check it.
    if (_lodash.default.get(validationDirtyMap, ['dirty', field])) {
      return _lodash.default.get(validationDirtyMap, ['dirty', field], false);
    } else {
      // If a dirty map entry for the field does not exist, use the overall dirty map setting
      // for this modal.  We need to do this as the DynamicValidateContinueButton will set the dirty
      // map for the top level validation id only.  It does not set it for the nested fields.
      // So if upon initial page load, we click the Continue button, the field level dirty map has
      // not been set up at all.
      return _lodash.default.get(validationDirtyMap, 'dirty');
    }
  };

  // Grab the display toggle and error messages for the tasks field.
  var tasksErrorMessages = errorMessage('tasks');
  // Display an error message if the field has been touched and has an error.
  var tasksDisplayError = isDirty('tasks') && displayError('tasks');
  var retObj = {
    tasksErrorMessages: tasksErrorMessages,
    tasksDisplayError: tasksDisplayError
  };
  return retObj;
};

// Checks if fieldname is dirty (includes check for dirty page)
exports.modalVal = modalVal;
var isDirty = function isDirty(validationDirtyMap, fieldName) {
  var dirtyToCheck = 'dirty';
  if (fieldName !== undefined) {
    dirtyToCheck = fieldName;
  }
  return _lodash.default.get(validationDirtyMap, 'dirtyPage') || _lodash.default.get(validationDirtyMap, dirtyToCheck, false);
};
exports.isDirty = isDirty;
var getErrorForField = function getErrorForField(validationErrors, fieldName) {
  return _lodash.default.get(_lodash.default.find(validationErrors, function (err) {
    return _lodash.default.get(err, fieldName) !== undefined;
  }), fieldName);
};
exports.getErrorForField = getErrorForField;
var parseError = function parseError(error) {
  if (_lodash.default.isArray(error)) {
    return _lodash.default.find(error, function (err) {
      return _lodash.default.get(err, 'isValid') === false;
    });
  } else {
    return error;
  }
};
exports.parseError = parseError;
var getFirstErrorForField = function getFirstErrorForField(validationErrors, fieldName) {
  return parseError(getErrorForField(validationErrors, fieldName));
};
exports.getFirstErrorForField = getFirstErrorForField;
var getFirstObjectError = function getFirstObjectError(errorObject) {
  var result = {};
  _lodash.default.forEach(errorObject, function (err) {
    var foundError = parseError(err);
    if (_lodash.default.get(foundError, 'isValid') === false) {
      result = foundError;
      return false;
    }
  });
  return result;
};

// Supports checking for errors for complex components that would come out of validateNestedRules or validateObject
exports.getFirstObjectError = getFirstObjectError;
var displayObjectErrors = function displayObjectErrors(validationErrors, validationDirtyMap, fieldName) {
  var err = _lodash.default.get(validationErrors, fieldName);
  var dirtyVal = isDirty(validationDirtyMap, fieldName);
  var displayError = err !== undefined && dirtyVal;
  var errorMessages = '';
  if (_lodash.default.isArray(err)) {
    var invalidErrs = _lodash.default.filter(err, function (e) {
      return e.isValid !== true;
    });
    if (_lodash.default.size(invalidErrs) > 0) {
      errorMessages = _lodash.default.get(invalidErrs, [0, 'message']);
    }
    err = _lodash.default.get(invalidErrs, 0);
    displayError = displayError && !_lodash.default.isEmpty(invalidErrs);
  } else if (err !== undefined) {
    displayError = displayError && _lodash.default.get(err, 'isValid') !== true;
    errorMessages = _lodash.default.get(err, 'message');
  }
  return _objectSpread(_objectSpread({}, _lodash.default.isObject(err) ? err : {}), {}, {
    displayError: displayError,
    errorMessages: errorMessages
  });
};
exports.displayObjectErrors = displayObjectErrors;
var getFirstInvalidErrorMessage = function getFirstInvalidErrorMessage(dirtyMap, errors) {
  if (_lodash.default.get(dirtyMap, 'dirty') || _lodash.default.get(dirtyMap, 'dirtyPage')) {
    return _lodash.default.get(_lodash.default.find(errors, function (err) {
      return !err.isValid;
    }), 'message');
  }
  return false;
};
exports.getFirstInvalidErrorMessage = getFirstInvalidErrorMessage;
var isDisplayError = function isDisplayError(dataErrors, fieldName) {
  if (dataErrors === undefined) {
    return false;
  }
  var value = _lodash.default.get(dataErrors, fieldName);
  return value !== undefined && !_lodash.default.isEmpty(value);
};
exports.isDisplayError = isDisplayError;
var errorMessages = function errorMessages(dataErrors, fieldName) {
  if (dataErrors === undefined) {
    return [];
  }
  var array = _lodash.default.get(dataErrors, fieldName);
  if (array !== undefined) {
    return _lodash.default.uniq(array).map(function (value, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: index
      }, (0, _reactHtmlParser.default)(value), " ");
    });
  }
  return [];
};
exports.errorMessages = errorMessages;
var checkWithinApplicationDeadline = function checkWithinApplicationDeadline(foData) {
  if (!foData) {
    return false;
  }
  return (0, _momentTimezone.default)().isBetween(foData.aplcnStartDate, foData.aplcnEndDate);
};

// export const checkProcessInstanceTerminated = (
//   entity,
//   token,
//   processInstanceId,
//   callback,
//   maxCalls
// ) => {
//   if (!maxCalls) {
//     maxCalls = 100;
//   }
//   REST.workflow
//     .checkProcessInstanceStatus(token, processInstanceId)
//     .then(REST.handler.handleResponse)
//     .then((status) => {
//       // TODO remove OpenAPI toggle code
//       if (status == 'ended' || _.get(status, 'result') == 'ended') {
//         callback(entity);
//       } else if (maxCalls > 0) {
//         //setTimeout(()=>
//         checkProcessInstanceTerminated(
//           entity,
//           token,
//           processInstanceId,
//           callback,
//           --maxCalls
//         );
//         //1000
//         //);
//       } else {
//         callback(null);
//       }
//     });
//   return true;
// };

// export const checkActivityCompleted = (
//   token,
//   processInstanceId,
//   activityId,
//   activityResponse,
//   callback,
//   maxTimeout
// ) => {
//   if (!maxTimeout) {
//     maxTimeout = 30000;
//   }

//   const endTime = Date.now() + maxTimeout;
//   let successful = false;
//   let foundStatus = null;

//   const getResult = async () => {
//     while (Date.now() < endTime) {
//       await new Promise((resolve) => setTimeout(resolve, 1000));

//       const res = await REST.workflow
//         .checkActivityStatus(token, processInstanceId, activityId)
//         .then(REST.handler.handleResponse);

//       foundStatus = _.isObject(res) ? _.get(res, 'result') : res;

//       if (
//         res !== undefined &&
//         (foundStatus == activityResponse ||
//           (activityResponse == ACTIVITY_RESPONSES.active &&
//             foundStatus == ACTIVITY_RESPONSES.ended))
//       ) {
//         return callback(foundStatus);
//       }
//     }

//     return new Error('Failed to retrieve response multiple times');
//   };

//   return getResult();
// };

// export const checkAndHandleEntityStatusSync = (
//   token,
//   entityId,
//   entityStatusWorkflow,
//   callback,
//   maxCalls
// ) => {
//   if (!maxCalls) {
//     maxCalls = 40;
//   }
//   const fetch_retry = async (n) => {
//     let error;
//     for (let i = 0; i < n; i++) {
//       try {
//         const entityData = await REST.dynamicData
//           .getEntityById(token, entityId)
//           .then(REST.handler.handleResponse);
//         if (
//           entityData &&
//           entityData.status &&
//           entityData.status == entityStatusWorkflow
//         ) {
//           return callback();
//         } else {
//           if (n === 1) {
//             return new Error('Failed to retrieve response multiple times');
//           }
//           return await fetch_retry(n - 1);
//         }
//       } catch (err) {
//         error = err;
//       }
//     }
//     throw error;
//   };
//   return fetch_retry(maxCalls);
// };

// export const getGrantActions = (
//   grant,
//   toggles,
//   permissions,
//   entitiesEnabled,
//   appExtension,
//   currentOrg,
//   hasOrgSubOrgRelationshipForEntitySix,
//   rolesToCheck,
//   pageEntityType,
//   parentList
// ) => {
//   const fo = _.get(grant, 'fundingOpportunityId');
//   const liqDeadLine = moment(
//     _.get(grant, 'payload.liquidationDeadline'),
//     'YYYY-MM-DDTHH:mm:ssZ'
//   );
//   const popStartDate = moment(
//     _.get(grant, 'payload.periodOfPerformance.startDate'),
//     'YYYY-MM-DDTHH:mm:ssZ'
//   );

//   const now = moment();
//   var actions = [];
//   if (
//     _.isEqual(_.get(grant, 'status'), STATUS_AWARD_ACCEPTED) &&
//     canViewAmendmentsAndPayments(permissions)
//   ) {
//     if (now.isAfter(popStartDate) && now.isBefore(liqDeadLine)) {
//       actions.push({
//         text: 'Request a payment',
//         value: 'payment',
//       });
//     }

//     actions.push({
//       text: 'Request an amendment',
//       value: 'amendment',
//     });
//   }

//   if (
//     hasOrgSubOrgRelationshipForEntitySix &&
//     _.includes(parentList, _.get(grant, 'organizationId')) &&
//     canContinueSubapplicationSubmitted(permissions, currentOrg, rolesToCheck) &&
//     _.isEqual(_.get(grant, 'status'), STATUS_PENDING_SUBMISSION)
//   ) {
//     actions.push({
//       text: 'Continue subapplication',
//       value: 'continueSubApplication',
//     });
//   }

//   if (
//     ((canViewSubapplication(permissions, currentOrg, rolesToCheck) ||
//       canViewAndContinueSubapplication(permissions, currentOrg, rolesToCheck)) &&
//       (_.isEqual(_.get(grant, 'status'), STATUS_PENDING_SUBMISSION) ||
//         _.isEqual(_.get(grant, 'status'), STATUS_SUBMITTED_TO_RECIPIENT) ||
//         _.isEqual(_.get(grant, 'status'), STATUS_INELIGIBLE) ||
//         _.isEqual(_.get(grant, 'status'), STATUS_NOT_SELECTED))) ||
//     (toggles !== undefined &&
//       _.includes(toggles, 'ReviewByRecipientTaskNav') &&
//       (_.isEqual(_.get(grant, 'status'), STATUS_APPROVED_BY_RECIPIENT) ||
//         _.isEqual(_.get(grant, 'status'), STATUS_DISAPPROVED_BY_RECIPIENT) ||
//         _.isEqual(_.get(grant, 'status'), STATUS_STOCKPILE))) ||
//     (_.includes(toggles, 'signSubPendAorFmaBric') &&
//       _.isEqual(_.get(grant, 'status'), STATUS_SUBMITTED_TO_FEMA))
//   ) {
//     actions.push({
//       text: 'View subapplication',
//       value: 'viewSubApplication',
//     });
//   }

//   if (
//     hasOrgSubOrgRelationshipForEntitySix &&
//     _.includes(parentList, _.get(grant, 'organizationId')) &&
//     canContinueSubapplicationSubmitted(permissions, currentOrg, rolesToCheck) &&
//     _.isEqual(_.get(grant, 'status'), STATUS_PENDING_SAR_SIGNATURE)
//   ) {
//     actions.push({
//       text: 'Continue subapplication',
//       value: 'continueSubApplication',
//     });
//   } else if (
//     (canViewSubapplication(permissions, currentOrg, rolesToCheck) &&
//       _.isEqual(_.get(grant, 'status'), STATUS_PENDING_SAR_SIGNATURE)) ||
//     (isSM(permissions) &&
//       pageEntityType === ENTITY_PAGE_TYPE_SUBGRANT &&
//       _.isEqual(_.get(grant, 'status'), STATUS_PENDING_SAR_SIGNATURE))
//   ) {
//     actions.push({
//       text: 'View subapplication',
//       value: 'viewSubApplication',
//     });
//   }

//   if (
//     _.includes(BEFORE_FINAL_SUBMISSION_STATUSES, _.get(grant, 'status')) &&
//     canViewAndContinueApplication(permissions)
//   ) {
//     if (
//       canContinueApplications(
//         permissions,
//         grant.status,
//         appExtension ? appExtension.extendedApplicationEndDate : grant.aplcnEndDate,
//         toggles,
//         _.get(grant, 'fundingOpportunityId')
//       )
//     ) {
//       actions.push({
//         text: 'Continue application',
//         value: 'continueApplication',
//       });
//     }
//     if (canViewAmendmentsAndPayments(permissions)) {
//       actions.push({
//         text: 'View application',
//         value: 'viewApplication',
//       });
//     }
//   }

//   if (
//     _.isEqual(_.get(grant, 'status'), STATUS_INELIGIBLE) &&
//     canViewAndContinueApplication(permissions)
//   ) {
//     actions.push({
//       text: 'View application',
//       value: 'viewApplication',
//     });
//   }

//   if (
//     (_.isEqual(_.get(grant, 'status'), STATUS_SUBMITTED_TO_FEMA) ||
//       _.isEqual(_.get(grant, 'status'), STATUS_NOT_SUBMITTED)) &&
//     canViewAmendmentsAndPayments(permissions)
//   ) {
//     if (
//       _.isEqual(_.get(grant, 'status'), STATUS_SUBMITTED_TO_FEMA) &&
//       canReopenApplications(
//         permissions,
//         grant.status,
//         appExtension ? appExtension.extendedApplicationEndDate : grant.aplcnEndDate,
//         toggles,
//         _.get(grant, 'fundingOpportunityId')
//       )
//     ) {
//       actions.push({
//         text: 'Reopen application',
//         value: 'reopenApplication',
//       });
//     }
//     actions.push({
//       text: 'View application',
//       value: 'viewApplication',
//     });
//   }

//   if (
//     canViewSubapplication(permissions, currentOrg, rolesToCheck) &&
//     (_.includes(parentList, currentOrg) || !parentList) &&
//     _.isEqual(_.get(grant, 'status'), STATUS_SUBMITTED_TO_RECIPIENT)
//   ) {
//     actions.push({
//       text: 'Review subapplication',
//       value: 'reviewSubApplication',
//     });
//   }

//   if (_.isEqual(_.get(grant, 'status'), STATUS_RETURNED_TO_SUBRECIPIENT)) {
//     actions.push(
//       {
//         text: 'Continue application',
//         value: 'continueApplication',
//       },
//       {
//         text: 'Continue subapplication',
//         value: 'continueSubApplication',
//       }
//     );
//   } else if (
//     (canViewSubapplication(permissions, currentOrg, rolesToCheck) &&
//       _.isEqual(_.get(grant, 'status'), STATUS_APPROVED_BY_RECIPIENT) &&
//       !_.isEqual(_.get(grant, 'inner_hits.payload.subApplicationId'), grant.entityId)) ||
//     _.isEqual(_.get(grant, 'status'), STATUS_DISAPPROVED_BY_RECIPIENT) ||
//     _.isEqual(_.get(grant, 'status'), STATUS_STOCKPILE)
//   ) {
//     actions.push({
//       text: 'Change subapplication status',
//       value: 'changeSubApplicationStatus',
//     });
//   }
//   const actionsForFo = _.filter(actions, (action) =>
//     _.includes(entitiesEnabled, action.value)
//   );
//   const enabledActions = _.filter(actionsForFo, (action) =>
//     isActionEnabled(toggles, action.value, 'fundingOpportunity', fo)
//   );
//   return enabledActions;
// };
exports.checkWithinApplicationDeadline = checkWithinApplicationDeadline;
var isStringOfNumbers = function isStringOfNumbers(value) {
  return !/^\d+$/.test(value) ? true : false;
};
exports.isStringOfNumbers = isStringOfNumbers;
var matchesToggle = function matchesToggle(action, toggle, entityType, entityId) {
  if (action === toggle) {
    return true;
  } else {
    var toggleOptions = _lodash.default.split(toggle, '-');
    return action == _lodash.default.get(toggleOptions, 2) && entityType === _lodash.default.get(toggleOptions, 0) && entityId == _lodash.default.get(toggleOptions, 1);
  }
};
exports.matchesToggle = matchesToggle;
var matchesFOIDForToggle = function matchesFOIDForToggle(toggle, entityId) {
  if (toggle === undefined || toggle === null || entityId === undefined || entityId === null) {
    return false;
  }
  var toggleOptions = _lodash.default.split(toggle, '-');
  return entityId == _lodash.default.get(toggleOptions, 1);
};

// export const findOffsetTopById = (id) => {
//   let obj = document.getElementById(id);
//   let offsetTop = 0;
//   while (obj != null) {
//     offsetTop += obj.offsetTop;
//     obj = obj.offsetParent;
//   }
//   return offsetTop;
// };

// export const orgRoles = (permissions, renderType, subOrgToggle) => {
//   const ROLES = retrieveRolesFromPermissions(permissions);
//   const existsSAR = ROLES.includes('21');
//   const existsAOR = ROLES.includes('1');

//   if (renderType === 'org' && subOrgToggle === true) {
//     if (existsSAR || existsAOR) {
//       return AOR_SAR_ROLES;
//     } else {
//       return SARROLES;
//     }
//   }
//   if (renderType === 'subOrg' && subOrgToggle === true) {
//     return SARROLES;
//   }
//   if (subOrgToggle === false) {
//     return ROLES;
//   }
// };
exports.matchesFOIDForToggle = matchesFOIDForToggle;
var roundUpOrDown = function roundUpOrDown(func, value, precision) {
  if (value === undefined || func === undefined || precision === undefined) {
    return value;
  }
  var rounder = Math.pow(10, precision);
  return (Math[func](value * rounder) / rounder).toFixed(precision);
};
exports.roundUpOrDown = roundUpOrDown;
var duplicatePhoneNumbers = function duplicatePhoneNumbers(phoneNumbers) {
  var finalPhoneNumbersArray = _lodash.default.map(phoneNumbers, function (pn) {
    return pn.areaCode + pn.phoneNumber + pn.phoneExtension;
  });
  var result = _lodash.default.uniq(finalPhoneNumbersArray).length !== finalPhoneNumbersArray.length;
  return result;
};
exports.duplicatePhoneNumbers = duplicatePhoneNumbers;
var lessThanTwoUniquePhoneNumbers = function lessThanTwoUniquePhoneNumbers(phoneNumbers) {
  var finalPhoneNumbersArray = _lodash.default.map(phoneNumbers, function (pn) {
    return pn.areaCode + pn.phoneNumber + pn.phoneExtension;
  });
  var result = _lodash.default.size(_lodash.default.uniq(finalPhoneNumbersArray)) < 2;
  return result;
};
exports.lessThanTwoUniquePhoneNumbers = lessThanTwoUniquePhoneNumbers;
var duplicateEmails = function duplicateEmails(primaryEmail, secondaryEmail) {
  var result = _lodash.default.toString(_lodash.default.trim(primaryEmail)) === _lodash.default.toString(_lodash.default.trim(secondaryEmail));
  return result;
};
exports.duplicateEmails = duplicateEmails;
var isNewDisasterLocationAdded = function isNewDisasterLocationAdded(options, prevDate) {
  if (options && prevDate) {
    var filterOptions = _lodash.default.find(options, function (item) {
      return (0, _momentTimezone.default)(item.entryDt, 'YYYY-MM-DD').isAfter((0, _momentTimezone.default)(prevDate));
    });
    return _lodash.default.size(filterOptions) > 0;
  }
  return false;
};
exports.isNewDisasterLocationAdded = isNewDisasterLocationAdded;
var getItemNameFromRef = function getItemNameFromRef(itemCode, refItems) {
  var itemData = _lodash.default.find(refItems, function (ref) {
    return _lodash.default.toInteger(ref.itemCode) === _lodash.default.toInteger(itemCode);
  });
  return _lodash.default.get(itemData, 'name');
};
exports.getItemNameFromRef = getItemNameFromRef;
var getBudgetItemsAtTier = function getBudgetItemsAtTier(items, refItems, predicate, remainingTiers) {
  var path = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var matchingTierItems = _lodash.default.map(items, function (item, itemKey) {
    if (remainingTiers == 0) {
      var itemCode = _lodash.default.get(item, 'itemCode', -1);
      var itemName = getItemNameFromRef(itemCode, refItems);
      var itemPath = "".concat(path, ".").concat(itemKey);
      var projectName = _lodash.default.get(item, 'additionalInformation.projectName', false) ? " ".concat(_lodash.default.get(item, 'additionalInformation.projectName')) : '';
      if (predicate(item)) {
        return {
          itemKey: itemKey,
          itemCode: itemCode,
          itemName: itemName,
          itemPath: itemPath,
          projectName: projectName
        };
      } else {
        return null;
      }
    } else {
      var nestedPath = "".concat(path ? path + '.' : '').concat(itemKey, ".children");
      return getBudgetItemsAtTier(_lodash.default.get(item, 'children', {}), refItems, predicate, remainingTiers - 1, nestedPath);
    }
  });
  return _lodash.default.filter(_lodash.default.flatMap(matchingTierItems), function (item) {
    return item !== null;
  });
};
exports.getBudgetItemsAtTier = getBudgetItemsAtTier;
var calculateStatuses = function calculateStatuses(sectionResults) {
  var sectionStatuses = {};
  _lodash.default.forEach(sectionResults, function (result, sectionName) {
    var canSubmit = _lodash.default.get(result, _constants.CAN_SUBMIT);
    var canSubmitPositive = _lodash.default.get(result, _constants.CAN_SUBMIT_POSITIVE);
    var status;
    if (!canSubmit) {
      status = 'incomplete';
    } else if (canSubmitPositive) {
      status = 'complete';
    } else {
      status = 'needsAttention';
    }
    _lodash.default.set(sectionStatuses, sectionName, status);
  });
  return sectionStatuses;
};
exports.calculateStatuses = calculateStatuses;
var buildParamString = function buildParamString(templateNames, params) {
  var paramString = '';
  _lodash.default.forEach(templateNames, function (name) {
    paramString += "templateName=".concat(name, "&");
  });
  _lodash.default.forEach(params, function (entry) {
    paramString += "".concat(entry.name, "=").concat(entry.value, "&");
  });
  paramString = paramString.slice(0, -1);
  return paramString;
};
exports.buildParamString = buildParamString;
var fillArray = function fillArray(collection, defaultValue) {
  var result = [];
  _lodash.default.each(collection, function (item, index) {
    if (_lodash.default.isUndefined(item) || _lodash.default.isNull(item) || item === '') {
      result.push(defaultValue);
    } else {
      result.push(item);
    }
  });
  return result;
};
exports.fillArray = fillArray;
var removeLeadingZeros = function removeLeadingZeros(value) {
  // '0010' -> 10, '00100.00' -> '100.00', '000' -> '0', '0000.00' -> '0.00'
  return value.replace(/^0+(?=\d)/, '');
};
exports.removeLeadingZeros = removeLeadingZeros;
var buildOrgRelationshipOrganizationProgramsUrl = function buildOrgRelationshipOrganizationProgramsUrl(isRestricted, orgId, subOrgId) {
  var endpoint;
  endpoint = "organizationprograms?isRestricted=".concat(isRestricted);
  if (checkIfDefinedNonNullAndNotEmptyString(subOrgId)) {
    endpoint += "&organizationId=".concat(orgId, "&subOrganizationId=").concat(subOrgId);
  } else if (checkIfDefinedNonNullAndNotEmptyString(orgId)) {
    endpoint += "&organizationId=".concat(orgId);
  }
  return endpoint;
};
exports.buildOrgRelationshipOrganizationProgramsUrl = buildOrgRelationshipOrganizationProgramsUrl;
var getUniqs = function getUniqs(collection, field) {
  // Get truthy fields
  return _lodash.default.chain(collection).map(field).uniq().compact().value();
};
exports.getUniqs = getUniqs;
var getPartName = function getPartName(itemCode, refItems) {
  var partId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var fundingStreams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var separator = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ' ';
  var itemCodeName = getItemNameFromRef(itemCode, refItems) || _lodash.default.toString(itemCode);
  var projectNameForPart = fundingStreams && partId ? _lodash.default.get(fundingStreams, partId + '.additionalInformation.projectName', '') : '';
  return _lodash.default.trim("".concat(itemCodeName).concat(separator).concat(projectNameForPart));
};

// Filter my permissions for only those in which there are not some excluded roles
// which the permission contains
exports.getPartName = getPartName;
var filterExcludedRolesFromPermissions = function filterExcludedRolesFromPermissions(permissions, roles) {
  return _lodash.default.filter(permissions, function (permission) {
    return !_lodash.default.some(roles, function (role) {
      return _lodash.default.endsWith(permission, ":".concat(role));
    });
  });
};
exports.filterExcludedRolesFromPermissions = filterExcludedRolesFromPermissions;
var getPartIdWithoutChildrenPath = function getPartIdWithoutChildrenPath(partId) {
  return partId.split('.').pop();
};

// export const isHttpOnlyCookie = () => {
//   return unpartitionedToggleIsOn(goStore.store.getState(), 'httpOnlyCookie');
// };
exports.getPartIdWithoutChildrenPath = getPartIdWithoutChildrenPath;
var encode = function encode(uri) {
  // Single quote is not encoded by encodeURIComponent
  return encodeURIComponent(uri).replace(/'/g, '%27');
};
exports.encode = encode;
var scrollIt = function scrollIt(el, destinationOffset) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  if (el) {
    var start = el.scrollTop;
    var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
    var destinationOffsetToScroll = destinationOffset;
    if ('requestAnimationFrame' in window === false) {
      el.scrollTop = destinationOffsetToScroll;
      return;
    }
    function scroll() {
      var now = 'now' in window.performance ? performance.now() : new Date().getTime();
      var time = Math.min(1, (now - startTime) / duration);
      var toScrollTo = Math.ceil(time * (destinationOffsetToScroll - start) + start);
      el.scrollTop = toScrollTo;
      if (toScrollTo === destinationOffsetToScroll || el.scrollTop > el.scrollHeight - window.innerHeight) {
        return;
      }
      requestAnimationFrame(scroll);
    }
    scroll();
  }
};

// gets the funding stream type for POP amendments (used for SAFER only)
exports.scrollIt = scrollIt;
var getFundingStreamType = function getFundingStreamType(fundingStreams) {
  var fundingStreamTypes = _lodash.default.map(fundingStreams, function (stream) {
    return _lodash.default.get(stream, 'fundingStreamType', '');
  });
  if (_lodash.default.includes(fundingStreamTypes, _constants.RECRUITMENT_AND_RETENTION)) {
    return _constants.RECRUITMENT_AND_RETENTION;
  } else if (_lodash.default.includes(fundingStreamTypes, _constants.HIRING_OF_FIREFIGHTERS)) {
    return _constants.HIRING_OF_FIREFIGHTERS;
  } else {
    return '';
  }
};
exports.getFundingStreamType = getFundingStreamType;
var reloadPage = function reloadPage() {
  window.location.reload();
};
// // fetches an updated POP from rules service
// export const fetchPOPupdate = async (payloadUpdate) => {
//   try {
//     const staticPayload = {
//       configType: 'fo',
//       ruleSet: 'amendmentPOP',
//     };
//     const payload = {...staticPayload, ...payloadUpdate};
//     const response = await REST.rules.getRulesByPayload('', payload);
//     const [[responseObject]] = await response.json();
//     return responseObject ? responseObject.updatedGrantAmendment : null;
//   } catch (error) {
//     console.log(error);
//   }
// };
exports.reloadPage = reloadPage;